var offerProductArray = [2411691278394,2411691311162,2411691343930,2411691475002];
var proceed = true;
//document ready
$(function() {
  checkLimitQty()
  function checkLimitQty(){
    for(var i = 0; i< offerProductArray.length; i++){
      $('[data-qty-prodid="'+offerProductArray[i]+'"]').attr('data-cart','true').addClass('limit-qty');
    }
  }
  var checkClearedCart = localStorage.getItem('ccleared');

  if(Number(checkClearedCart) != 1) {
    // To clear cart for free pillow issue
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      dataType: 'json',
      success: function(){
        console.log('Cart cleared!');
        localStorage.setItem('ccleared', 1);
      }
    });
  }

  var currentProductID = parseInt($('.pdp-cart-items').attr('data-product-id'));
  var oldFlickityCreate = window.Flickity.prototype._create;
  window.Flickity.prototype._create = function(){
    var that = this;
    if(this.element.addEventListener){
      this.element.addEventListener('load', function(){
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  objectFitImages();
  header.loadMegaMenu();
  header.init();
  
    searchAutocomplete.init();
  
  utils.pageBannerCheck();
  slideshow.init();
  testimonial.init();
  videoSection.init();
  gallery.init();
  featuredPromotions.init();
  featuredCollectionSection.init();
  collectionSidebarFilter.init();
  cart.init();
  mapFunction.init();


  productPage.initializeQuantityBox();
  productPage.init();
  productPage.relatedProducts();

  recentlyViewed.init();

  // Setup a timer
  var resizeTimeout;

  // Listen for resize events
  window.addEventListener('resize', function ( event ) {

    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {

        // Reset timeout
        resizeTimeout = null;

        // Run our resize functions
        if($(window).width() <= 1024) {
          cart.init();
          header.unload();
          header.init();
        }

      }, 66);
    }
  }, false);

  //Lightbox default options
  //https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function(instance, slide) {
    if (instance.current.type == 'image'){
      slide.$content.wrapInner( "<div class='fancybox-image-wrap'></div>" )
    }
    if (instance.group.length > 1){
      slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>'+ svgArrowSizeLeft +'</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>'+ svgArrowSizeRight +'</span></a>')
    }
  }

  //backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  $('.size_chart_fancybox').fancybox();

  //Search input hiding
  //get current input
  var currentValue = $(".search_form input[name='q']").val()
  //return amount without *
  if ($(".search_form input[name='q']").length > 0){
    $(".search_form input[name='q']").val( currentValue.replace('*', '') );
  }

  $('#sort-by').val($('#sort-by').data('default-sort'));

  $('body')
    .on('change', '#tag_filter, #sort-by', function() {
      quickFilter.init();
  });

  $('body')
    .on('change', '#blog_filter', function() {
      var url = $(this).val();
      window.location = url;
  });

  $('input, select, textarea').on('focus blur', function(event) {
    $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
  });

  //Collection sidebar filter
  //Check the checkbox values
  $('body').on('change', '[data-option-filter] input', function(){
    quickFilter.init();
    $("html, body").animate({
      scrollTop: ($('#pagecontent').offset().top)
    }, 500);
  })

  $('body').on('click', '[data-reset-filters]', function(){
    collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', function(){
    var selectedOption = $(this).parents('.filter-active-tag');
    collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', function(e) {
      $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', function(e) {
      var currentVariant = $('.js-quick-shop select[name="id"]').val();
      if (currentVariant && globalQuickShopProduct){
        quickShop.updateVariant(currentVariant);
      }
  });

  
    quickShop.init();
  

  var touchStartPos = 0;

  //Detecting swipe vs tap
  $(document).bind("touchstart", function (e) {
    touchStartPos = $(window).scrollTop();
  }).bind("touchend", function (e) {
      var distance = touchStartPos - $(window).scrollTop();
      if (distance > 20 || distance < -20) {
          e.preventDefault;
      }
  });

  $('body').on('click', '.sidebar .parent-link--false', function(e) {
    e.preventDefault();
    $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  

  if(window.location.pathname.indexOf('/comments') != -1) {
    $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
  }

  $('body').on('mouseenter', '.icon-search', function() {
    $('.search-terms').focus();
  });

  $('body').on('click', '.icon-search', function() {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', function() {
    $(this).parent().submit();
  });

  if ($(window).width() > 1024) {
    $(".animate_right").waypoint(function() {
      $(this.element).addClass("animated fadeInRight");
    }, { offset: '70%' });
    $(".animate_left").waypoint(function() {
      $(this.element).addClass("animated fadeInLeft");
    }, { offset: '70%' });
    $(".animate_up").waypoint(function() {
      $(this.element).addClass("animated fadeInUp");
    }, { offset: '70%' });
    $(".animate_down").waypoint(function() {
      $(this.element).addClass("animated fadeInDown");
    }, { offset: '70%' });
  }

  //backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: usePageDots,
    imagesLoaded: true,
    arrowShape: arrowSize,
    lazyLoad: 2
  });

  utils.createAccordion('.toggle-all--true', 'h4.toggle,button.toggle', 'ul.toggle_list');
  utils.createAccordion('.footer_menu', 'h2', 'ul');
  utils.createAccordion('.footer_content', '.toggleEle', 'div.toggle_content');
  utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

  // utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > .parent-link--true', 'li.sublink ul');
  utils.mobileAccordion('#mobile_menu', 'li.sublink > .parent-link--true', 'li.sublink ul');
  utils.mobileAccordion('#mobile_menu', 'li.sublink > .parent-link--false', 'li.sublink ul');

  utils.initializeTabs();
  utils.resizeActionButtons();
  faqAccordion.init();

  $(window).on('resize', function() {
    utils.resizeActionButtons();
  });

  //Sidebar toggle check
  if ($(window).width() <= 1024) {
    utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
  }

  $('body').on('click', '.menu-toggle', function(e) {
    var $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
  });

  if ($(window).width() >= 959) {
    var modal_width = '870px';
    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1110px'
    }
  }

  
      $('body').on('click', '.collection_swatches', function() {
        $('.swatch span, .swatch a', $(this)).each(function() {
          if($(this).data("image").indexOf("no-image") == -1) {
            $('<img/>')[0].src = $(this).data("image");
          }
        });
      });
      $('body').on('click', '.swatch a', function() {
        $(this).attr('aria-current','true').closest('.swatch').siblings('.swatch').find('a').removeAttr('aria-current');
        if($(this).data("image").indexOf("no-image") == -1) {
          $(this).closest('.thumbnail').find('img:not(.secondary)').attr('src', $(this).data("image"));
          $(this).closest('.thumbnail').find('img:not(.secondary)').attr('srcset', $(this).data("image"));
        }
        
        $(this).closest('fieldset').siblings('.pw-link').attr('href', $(this).data("variant"));
        var variantAvailable = $(this).attr('data-available'); 
        var compPrice = $(this).attr('data-compareprice');
        var actualPrice = $(this).attr('data-price');
        var apVal = parseFloat(actualPrice.split('$')[1]);
        var cpVal = parseFloat(compPrice.split('$')[1]);

        console.log('actualPrice: '+actualPrice+' compPrice: '+compPrice+' variantAvailable: '+variantAvailable);

        if(variantAvailable == "true") {
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price').find('.sold_out').remove();
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .money').text(actualPrice).show();
          $(this).closest('fieldset').find('.product-info__caption').find('.price .money').text(actualPrice).show();
          $(this).closest('fieldset').find('.product-info__caption').find('.price').find('.sold_out').remove();
          if(compPrice != '') {
            if(cpVal == apVal) {            
//               $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .was_price .money').hide();
              $(this).closest('fieldset').siblings('.pw-link').find('.sale_banner.thumbnail_banner').addClass('opacity0');
//               $(this).closest('.gallery-cell').find('.product-info__caption').find('.price .was_price .money').hide();
              $(this).closest('.gallery-cell').find('.sale_banner.thumbnail_banner').addClass('opacity0');
            }
            else if (cpVal > apVal) {
              if(!$(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price').find('span').hasClass('was_price')) {
                //$(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price').append('<p class="was_price compPrice"><p class="money"></p></p>')
              }
              if(!$(this).closest('.gallery-cell').find('.product-info__caption').find('.price').find('span').hasClass('was_price')) {
                //$(this).closest('.gallery-cell').find('.product-info__caption').find('.price').append('<p class="was_price compPrice"><p class="money"></p></p>')
              }
              $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .was_price .money').text(compPrice).show();
              $(this).closest('fieldset').siblings('.pw-link').find('.sale_banner.thumbnail_banner').removeClass('opacity0');
              $(this).closest('.gallery-cell').find('.product-info__caption').find('.price .was_price .money').text(compPrice).show();
              $(this).closest('.gallery-cell').find('.sale_banner.thumbnail_banner').removeClass('opacity0');
            }
          }
          else {
            $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .was_price .money').hide();
            $(this).closest('fieldset').siblings('.pw-link').find('.sale_banner.thumbnail_banner').addClass('opacity0');
            $(this).closest('.gallery-cell').find('.product-info__caption').find('.price .was_price .money').hide();
            $(this).closest('.gallery-cell').find('.sale_banner.thumbnail_banner').addClass('opacity0');
          }
          
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price').find('.sold_out').remove();
          $(this).closest('.gallery-cell').find('.product-info__caption').find('.price').find('.sold_out').remove();
          
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .money').show();
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .was_price .money').show();
           
          $(this).closest('.gallery-cell').find('.product-info__caption').find('.price .money').show();
          $(this).closest('.gallery-cell').find('.product-info__caption').find('.price .was_price .money').show();
          
          $(this).closest('.gallery-cell').find('.product-info__caption').find('.price .was_price').show();
          $(this).closest('.gallery-cell').find('.product-info__caption').find('.price .is-price').show();
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .was_price').show();
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .is-price').show();
          
        }

        else {
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .money').hide();
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .was_price .money').hide();
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price').find('.sold_out').remove(); 
          
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price').append('<span class="sold_out">Sold Out</span>');
          $(this).closest('fieldset').siblings('.pw-link').find('.sale_banner.thumbnail_banner').addClass('opacity0');
          
          $(this).closest('.gallery-cell').find('.product-info__caption').find('.price .money').hide();
          $(this).closest('.gallery-cell').find('.product-info__caption').find('.price .was_price .money').hide();
          $(this).closest('.gallery-cell').find('.product-info__caption').find('.price').find('.sold_out').remove();
          
          $(this).closest('.gallery-cell').find('.product-info__caption').find('.price').append('<span class="sold_out">Sold Out</span>');
          $(this).closest('.gallery-cell').find('.sale_banner.thumbnail_banner').addClass('opacity0');
          
          $(this).closest('.gallery-cell').find('.product-info__caption').find('.price .was_price').hide();
          $(this).closest('.gallery-cell').find('.product-info__caption').find('.price .is-price').hide();
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .was_price').hide();
          $(this).closest('fieldset').siblings('.pw-link').find('.product-info__caption').find('.price .is-price').hide();
        }

      });
  

  //Terms of service settings for minicart

  //Terms of service settings for minicart
  

  


  
    imageFunctions.showSecondaryImage();
  

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on('submit', function (e) {
      if($('input[name="challenge"]', $cf).val() !== "true") {
        $.ajax({
          type: $cf.attr('method'),
          url: $cf.attr('action'),
          data: $cf.serialize(),
          success: function (data) {
            $cf.fadeOut("slow", function(){
              $cf.prev('.message').html("Thank you for joining our mailing list!");
            });
          },
          error: function(data) {
            $('input[name="challenge"]', $cf).val('true');
            $cf.submit();
          }
        });
        e.preventDefault();
      }
    });
  });

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  
    enableLoadMoreProducts();
  

  

  

  

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

  function ajaxSubmitCart(cart) {
    $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function ajaxUpdateCart(lineID, quantity, parent) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: quantity, line: lineID },
      success: function (data) {
        refreshCart(data);

        var lineIDIndex = lineID - 1;

        //check to see if there are correct amount of products in array
        if (typeof data.items[lineIDIndex] === "undefined"){
          var updated_quantity = 0;
        } else {
          var updated_quantity = data.items[lineIDIndex].quantity;
        }

        if(quantity > 0 && quantity != updated_quantity) {
          if (updated_quantity == 1) {
            items_left_text = "item left";
          } else {
            items_left_text = "items left";
          }

          $('.warning--quantity').remove();

          var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
          parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
          parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
        } else if (parent.is('#cart_form')) {
          $("#cart_form").submit();
        }
      }
    });
  }

  //code to update multiple cart items based on group
  function ajaxUpdateCartByGroup(gp_id, quantity, parent) {  
    
    if(quantity <= 0){
      var itemsToRemove = parent.find('input.quantity[gp_id='+ gp_id +']');
    }else{
      if(parent.is('#cart_form')){
        var itemsToRemove = parent.find('div.cartRow:not(.limited)').find('input.quantity[gp_id='+ gp_id +']');
      }else{
        var itemsToRemove = parent.find('li.cart_item:not(.limited)').find('input.quantity[gp_id='+ gp_id +']');
      }      
    }    
    
    var itemsKeys = [],
        currentIndex = 0;

    //Pushing the line item keys to an array to remove
    itemsToRemove.each(function(){
      itemsKeys.push($(this).data('line-key'));
    });
    
    updateItem(itemsKeys[currentIndex]);

    //function to update items in cart and quick cart
    function updateItem(itemId){      
      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        async: false,
        data: { quantity: quantity, id: itemId },
        success: function () {
          currentIndex++;
          if(currentIndex < itemsKeys.length){
            updateItem(itemsKeys[currentIndex]);
          }else{
            if(parent.is('#cart_form')){
              location.reload();
            }else{
              $.ajax({
                url: '/cart.js',
                dataType: 'json',
                cache: false,
                type: 'get',
                success: function (cart) {
                  refreshCart(cart);
                }
              });
            }
          }
        }
      });
    }    
  }

  
  
  
  
  function refreshCart(cart) {        
    $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart = $(".cart_content form");
    var discounted_price_total = 0;
    var total_savings = 0;

    $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
    
    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('.js-cart_content__form').addClass('hidden');
      $('.cartCountWrapper').addClass('hidden');
      $('.cartCountWrapper .countText').removeClass('items').removeClass('item');
      $('.js-icon-cart-span-text').text('Cart is Empty') ;
    } else {
      
      if(cart.item_count == 1){
        $('.cartCountWrapper .countText').text('Item in cart');
      } else{
        $('.cartCountWrapper .countText').text('Items in cart');
      }

      $('.js-icon-cart-span-text').text('In Cart '+cart.item_count+' product');
      $('.js-empty-cart__message').addClass('hidden');
      $('.js-cart_content__form').removeClass('hidden');
      $('.cartCountWrapper').removeClass('hidden');

      $.each(cart.items, function(index, item) {
        var line_id = index + 1;
        var limitedClass = "";

        if(item.properties && item.properties['limited']){
          limitedClass = "limited";
        }

        cart_items_html += '<li data-id="'+item.product_id+'" class="cart_item clearfix abc ' + limitedClass + '">' +
          '<a href="' + item.url +'">';
        if (item.image) {
          cart_items_html += '<div class="cart_image">' +
              '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
            '</div>';
        }
        else {
        	cart_items_html += '<div class="cart_image">' +
              '<img src="//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_320x.gif" alt="' + htmlEncode(item.title) + '" />' +
            '</div>';
        }

        cart_items_html += '<div class="cart_item__title"><div class="item_title">' + item.title;

        if(item.properties) {
          $.each(item.properties, function(title, value) {
            //Printing properties except gp_id, used for identifying the grouping of products
            if(title !== 'gp_id' && title !== 'limited'){
              if (value) {
                cart_items_html += '<div class="line-item '+title+'" >' + title +': ' + value + '</div>';
              }
            }            
          });
        }
        cart_items_html += '</div></a>';
        
         
        
        if(item.properties &&  item.properties['gp_id']){
          var gp_id="gp_id='" + item.properties['gp_id'] + "'";
        }

        cart_items_html += '<div class="left product-quantity-box">' +
            
        
          '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
          '<input data-prod-id="'+item.product_id+'" type="number" min="0" class="quantity"  name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" data-line-key="' + item.key +'" ' + gp_id + '/>' +
          '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
          
          
          '</div>' +
        '</div>';

        cart_items_html += '<p class="right price">';
		var count = 0;
        
          $.ajax({
            dataType: "json",
            async: false,
            cache: false,
            url: "/products/" + item.handle + ".js",
            success: function(data) {
              var variant_id = item.variant_id;
              var variant = $.grep(data.variants, function(v) {
                return v.id == variant_id;
              });
              
              if(item.original_price > item.discounted_price) {
//                 cart_items_html += ' <strong><span class="" style="text-align:left; color:#707070;">Regular price:</span></strong><span class="money was_price" style="text-align:left; padding-left:0; color:#707070; text-decoration:line-through;">' + Shopify.formatMoney(item.original_price, $('body').data('money-format')) + '</span> ';
              } else {
                if(variant[0] && variant[0].compare_at_price > item.price) {
//                   cart_items_html += ' <strong><span class="" style="text-align:left; color:#707070;">Regular price:</span></strong><span class="money was_price" style="text-align:left; padding-left:0; color:#707070; text-decoration:line-through;">' + Shopify.formatMoney(variant[0].compare_at_price, $('body').data('money-format')) + '</span> ';
                }
              }

              if(variant[0] && variant[0].compare_at_price > item.price) {
                discounted_price_total += item.price * item.quantity;
                total_savings += variant[0].compare_at_price * item.quantity;
              }
              if(item.vendor == 'Repair Kits') {
                count = 1;
              }
            }
            
          });
        if(count == 1) {
        cart_items_html += '<p class="money">Free</p></p></div>';
        }
        else {
          cart_items_html += '<strong style="text-align:left;"><span class="" style="text-align:left; padding-left:0;">Costco price:</span></strong><span class="money" style="text-align:left; color:#e57100;">' + Shopify.formatMoney(item.discounted_price, $('body').data('money-format')) + '</span></p>' + '</div>';
        }
          
      });

      cart_action_html += '<span class="right"> <span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span> <span class="text">Subtotal</span>';

      if(total_savings > 0 ) {
        cart_savings_html = '<p class="right"><p class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')) + '</p></p>' +
            '<p class="text">Total Savings</p>';
      } else {
        cart_savings_html = "";
      }
    }

    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_subtotal').html(cart_action_html);
    $('.js-cart_savings').html(cart_savings_html);

        
    
    getCartInfo(currentProductID, cart);
    
    // Code for free gift Black Monday/Cyber Sale
    

    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
      BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
    }
}
  
  $('body').on("change", "#cart_form input.quantity", function() {
    var gp_id = $(this).attr('gp_id');
    $('#cart_form .subtotal').css('pointer-events', 'none');
        
    if(typeof gp_id !== 'undefined'){
      ajaxUpdateCartByGroup(gp_id, $(this).val(), $(this).parents('#cart_form'))
    }else{
      ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
    }
  });

  $('body').on("change", ".cart_content input.quantity", function() {
    var gp_id = $(this).attr('gp_id');

    if(typeof gp_id !== 'undefined'){
      ajaxUpdateCartByGroup(gp_id, $(this).val(), $(this).parents('.cart_content'));
    }else{
      ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
    }    
  });
      /* =================================================Free Gift Code=================================================*/
  $(document).on('click', '.fg-close', function() {
    $(this).closest('.freeGiftPopup').hide();
  });
  
  
//   var freeProductArray = [2411685838906,2411692818490,2411686494266];
  var freeProductArray = [];
  var freeQuantityVal = 0;
  var url = "/cart/add.js";
  
  var productArr= "";
  
    
  
  
  
  
  
   var giftId = 2509899923514; 
  /* =================================================Free Gift Code End=================================================*/
  
	checkFreeGiftQty();
 
  //check free gift quantity
  function checkFreeGiftQty(){
    $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        success: function (cart) {
          for(var i = 0; i<= cart.items.length-1; i++){
            var cartItem = cart.items[i];         
            for ( var key in cartItem.properties ) {
              if(cartItem.properties[key] == 'free' && cartItem.quantity > 1){              
                changeQtyFreeGift(i+1)
              }
            }            
          }
        },
        error:function(){}
    });
  }
  
  function changeQtyFreeGift(lineItem){
    $.ajax({                 
      data: { 
        quantity: 1,
        line: lineItem
      },
      url: "/cart/change.js", 
      method: "POST",   
      dataType: "json",
      success: function(response){
        location.reload();
      }            
    });
  }
  
  function buildCart(){
    $.ajax({
      url: '/cart.js',
      dataType: "json",
      cache: false,
      success: function(cart) {
        refreshCart(cart);
        if($('body').hasClass('fancybox-active')) {
          $.fancybox.close();
        }

        if($('#header').is(':visible')) {
          $('#header .cart_container').addClass('active_link');
        } else if ($('.sticky_nav--stick').length) {
          $('.sticky_nav .cart_container').addClass('active_link');
        } else {
          $('.top_bar .cart_container').addClass('active_link');
        }

        //block scrolling on mobile
        if ($(window).width() <= 1024) {
          var $cart_container = $(this).parent();
          if($cart_container.hasClass('active_link')) {
            $('body').addClass('blocked-scroll');
          } else {
            $('body').addClass('blocked-scroll');
          }
        }
        // Code for free gift Black Monday/Cyber Sale
        
      }
    });
  }
  
  // Code for free gift Black Monday/Cyber Sale
  Shopify.handleFreeGift = function(){
    let $cartContent,$cartTotal=0,$freeGiftInCart;
    let $freeGift = window.FREE_PRODUCT;    
    let $limit = Number(399);
    if($('body').attr('id') == 'page-cart'){
      $cartContent = $('#cart_form');
      $cartContent.find('.cartRow').each(function(){
        let $this = $(this);
        if($this.attr('data-id').trim() !== '4539848622122'){
          let $qty = $this.find('.quantity').val();
          $cartTotal += $qty*Number($this.find('.money:not(.was_price)').text().replace('$', '').replace(/\,/g, ''));
        }
      });
      $freeGiftInCart = $cartContent.find('.cartRow[data-id="' + $freeGift.id + '"]').length >= 1 ? true : false;
    }else{
      $cartContent = $('.cart_content').eq(0);
      $cartContent.find('.cart_items li').each(function(){
        let $this = $(this);
        if($this.attr('data-id').trim() !== '4539848622122'){
          let $qty = $this.find('.quantity').val();
          $cartTotal += $qty*Number($this.find('.money:not(.was_price)').text().replace('$', '').replace(/\,/g, ''));
        }
      });
      $freeGiftInCart = $cartContent.find('.cart_items li[data-id="' + $freeGift.id + '"]').length >= 1 ? true : false;
    }        

    if($cartTotal > $limit){
      if(!$freeGiftInCart){
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: {
            id: window.FREE_PRODUCT.variants[0].id,
            quantity: 1
          },
          success: function(itemData) {
            if($('body').attr('id') == 'page-cart'){
              location.reload();
            }else{
              buildCart();
            }            
          }
        });
      }      
    }else {
      if($freeGiftInCart){
        $.ajax({
          url: '/cart/change.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: {
            id: window.FREE_PRODUCT.variants[0].id,
            quantity: 0
          },
          success: function(itemData) {
            // buildCart();
            location.reload();
          }
        });
      }
    }      
  }

  Shopify.freeGiftCSS = function(){
    let $freeGift = window.FREE_PRODUCT;
    let $css = `<style>
      li.cart_item[data-id="` + $freeGift.id + `"] .product-quantity-box{
        display: none;
      }
      .cartRow[data-id="` + $freeGift.id + `"] .product-quantity-box{
        visibility: hidden;
      }
    </style>`;
    $($css).appendTo( "head" );
  }

  // Code for free gift Black Monday/Cyber Sale
  

  
    $('body').on('submit', ".product_form form, .shopify-product-form", function(e) {
      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
      var qty = $(this).find('[data-form-quantity="quantity"]').val();
      var isFreeGift = $addToCartForm.find('.gwp_variant_id').length > 0;
      
 		var currentProductID = parseInt($('.pdp-cart-items').attr('data-product-id'));
      if($addToCartForm.find('.add_to_cart').attr('data-currentProductExist')=='true'){      
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          success: function (cart) {
            var proceed = true;
            var count = 0;  
            for(var i = 0; i<= cart.items.length-1; i++){
              var cartItem = cart.items[i];
              var carItemProductID = cart.items[i].product_id;
              for(var j = 0; j<= offerProductArray.length-1; j++){
                //console.log("carItemProductID:- "+carItemProductID);
                //console.log("offerProductArray[j]:- "+offerProductArray[j]);
                if(offerProductArray[j] == carItemProductID){
                  if(cartItem.quantity >1){
                    count = 2;
                  }
                  else{
                    count = count + 1;
                  }
                  //console.log("count:- "+count);
                }
              }  
            }
            
            if(qty == 2 && count == 1){
              alert('already 1 product from sale items is in cart, only 1 sale items can be add now')
            }
            else{
            if(count >= 2){
              proceed = false;            
              for(var i = 0; i<= cart.items.length-1; i++){
                var cartItem = cart.items[i];
                var carItemProductID = cart.items[i].product_id;
                for(var j = 0; j<= offerProductArray.length-1; j++){
                  //console.log("carItemProductID:- "+carItemProductID);
                  //console.log("offerProductArray[j]:- "+offerProductArray[j]);
                  if(offerProductArray[j] == carItemProductID){
                    if(currentProductID == offerProductArray[j]){
                      $('.add_to_cart[data-id="'+offerProductArray[j]+'"]').hide();
                      $('.offer-message').show();
                      $('.cart_item[data-id="'+offerProductArray[j]+'"').find('.product-plus').addClass('remove-click').css('pointer-events','none');
                    }
                  }
                }  
              }   
              for(var j = 0; j<= offerProductArray.length-1; j++){
                $('.cart_item[data-id="'+offerProductArray[j]+'"]').find('.product-plus').addClass('remove-click').css('pointer-events','none');
              }            
              refreshCart(cart)
            }
            else if(count > 0){
              proceed = true; 
              for(var j = 0; j<= offerProductArray.length-1; j++){
                $('.add_to_cart[data-id="'+offerProductArray[j]+'"]').show();
                $('.offer-message').hide();
              }
            }
            else{
              proceed = true;
              $('.add_to_cart[data-id="'+currentProductID+'"]').show();
              $('.offer-message').hide();
            } 
            if( proceed == true){
              $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: $addToCartForm.serialize(),
                beforeSend: function() {
                  $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                  $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
                },
                success: function(itemData) {
                  $addToCartBtn.find('.checkmark').addClass('checkmark-active');
                  freeQuantityVal = $('#quantity').val();
                  var productDataId = $addToCartBtn.attr('data-id');
                  if(freeProductArray) {
                    for(i in freeProductArray) {

                      if(productDataId == freeProductArray[i]) {
                        $('.freeGiftPopup').show();
                      }
                    }
                  }

                  window.setTimeout(function(){
                    $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                    $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                    $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                  }, 1000);
                  
                  //Adds a free gift if the product is associated with free gift - product-form.liquid contains a hidden input field with class gwp_variant_id                         
                  if(isFreeGift){
                    freeGWPAdd($addToCartForm, itemData.quantity);
                  }else{
                    buildCart();
                  }     
                },
                error: function(XMLHttpRequest) {
                  var response = eval('(' + XMLHttpRequest.responseText + ')');
                  response = response.description;
                  $('.warning').remove();

                  var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
                  $addToCartForm.after(warning);
                  $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                  $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
                }
              });
            }
            }
          }
        });
      }
      else{        
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: $addToCartForm.serialize(),
              beforeSend: function() {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
                $addToCartBtn.find('.js-added-sr-only').text($addToCartBtn.find('.js-added-sr-only').data('text-sr-finish'));
              },
              success: function(itemData) {
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');
                freeQuantityVal = $('#quantity').val();
                var productDataId = $addToCartBtn.attr('data-id');
                if(freeProductArray) {
                  for(i in freeProductArray) {

                    if(productDataId == freeProductArray[i]) {
                      $('.freeGiftPopup').show();
                    }
                  }
                }

                window.setTimeout(function(){
                  $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                  $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                  $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                  $addToCartBtn.find('.js-added-sr-only').text($addToCartBtn.find('.js-added-sr-only').data('text-sr-start'));
                }, 1000);

                //Adds a free gift if the product is associated with free gift - product-form.liquid contains a hidden input field with class gwp_variant_id
                if(isFreeGift){
                  freeGWPAdd($addToCartForm, itemData.quantity);
                }else{
                  buildCart();
                }                                 
              },
              error: function(XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
                $('.warning').remove();

                var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
                $addToCartForm.after(warning);
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
              }
            });
      }

      return false;
    });
  

  function freeGWPAdd(form, qty){
    let $freeVariantId = form.find('.gwp_variant_id').val();
    let $gp_id = form.find('[name="properties[gp_id]"]').val();
    let limitToOne = form.find('.gwp_limit').val();
    
    if(limitToOne === 'true'){
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: function(cart) {
          let itemAlreadyInTheCart = false;
          $.each(cart.items, function(){
            let item = this;            
            if(item.variant_id === Number($freeVariantId)){
              itemAlreadyInTheCart = true;
            }            
          });

          if(!itemAlreadyInTheCart){
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: {
                id: $freeVariantId,
                quantity: 1,
                properties: {
                  gp_id: $gp_id,
                  limited: true
                }
              },
              success: function (cart) {
                buildCart();
              }
            });
          }else{
            buildCart();
          }
        }
      });
    }else{
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: {
          id: $freeVariantId,
          quantity: qty,
          properties: {
            gp_id: $gp_id
          }
        },
        success: function (cart) {
          buildCart();
        }
      });
    }
  }
  /*=======================================================Free Gift================================================*/
  
  /*=====================================================cart Page Loop=====================================================*/
  
  var mainProducts = $('div[data-id]').length;
  var count = 0;
  for(i=0;i<mainProducts;i++) {
    for(j in freeProductArray) {
      var specifiedProducts = $('div[data-id]').eq(i).attr('data-id');
      if(specifiedProducts == freeProductArray[j]) {
        var k = $('div[data-id]').eq(i).find('.quantity').val();
        count = count+parseInt(k);
      }
    }
  }
  var freeGiftLen = $('div[data-varid="'+giftId+'"]').find('.quantity').val();
  if(freeGiftLen == undefined) {
          freeGiftLen = 0;
        }

  if(count-freeGiftLen > 0) {
    $('.freeGiftPopup').show();
    freeQuantityVal = count-freeGiftLen;  
    url = "/cart/add.js";
  }
//   else if(count-freeGiftLen < 0) {
//     $('.freeGiftPopup').show();
//     freeQuantityVal = count;
//     url = "/cart/change.js";          
//   }
  
  /*=====================================================cart Page Loop End=====================================================*/
  
  
  $(document).on('click', '#add-free-gift', function() {
    $.ajax({                 
      data: { 
        quantity: freeQuantityVal,
        id: giftId,
      },
      url: url, 
      method: "POST",   
      dataType: "json",
      success: function(response){
        window.location.href="/cart";
      },
      error: function(response) {

      }
    });
  });
  
  
  /*=======================================================Free Gift End================================================*/
  productPage.productSwatches();
  
  /* ======================================================Product Registration======================================================*/
  $(document).on('click', '.checkBox', function() {
    if($(this).is('.additionCheckYes:checked')) {
      $('.additionalFields').slideDown(300);
    }
    else if($(this).is('.additionCheckNo:checked')) {
      $('.additionalFields').slideUp(300);
    }
    else if($(this).is('.extendCheckYes:checked')) {
      $('.extendedForm').slideDown(300);
      $('.registerBtnWrap').slideDown(300);
    }
    else if($(this).is('.extendCheckNo:checked')) {
      $('.extendedForm').slideUp(300);
      $('.registerBtnWrap').slideDown(300);
    }
  });
  /* ======================================================Product Repair======================================================*/
  $(document).on('click', '.rd-header', function() {
    var this_ = $(this);
    this_.siblings('.rd-ul').slideToggle(300);
  });
  $(document).on('click', '.rd-ul a', function() {
    var thisEle = $(this);
    var thisVal = thisEle.text();
    var thisIndex = thisEle.parents('li').index();
    thisEle.parents('.repairDropdown').find('.rd-header').text(thisVal);
    thisEle.parents('.rd-ul').slideUp(300);
    $('.finderInput input').val('');
    if(thisEle.parents('.repairDropdown').siblings('.finderInput:visible').length < 1) {
      thisEle.parents('.repairDropdown').siblings('.finderInput').slideDown(300);
    }    
    if(thisEle.parents('.finderWrap').find('.finderBtnWrap:visible').length < 1) {
      thisEle.parents('.finderWrap').find('.finderBtnWrap').slideDown(300);
    }
    thisEle.parents('.repairDropdown').siblings('.finderInput').find('.finderVal').eq(thisIndex).show().siblings('.finderVal').hide();    
  });
  
  $(document).on('click', function(e) {
    if(!$(e.target).parents('div').hasClass('finderWrap')) {
      if($('.repairDropdown .rd-ul:visible').length > 0) {
        $('.rd-header').click();
      }
    }
  });
  
  $(document).on('click', '.finderSubmit', function() {
    var VisiInpVal =  $(this).parents('.finderWrap').find('input:visible').val();
    var numberVal = $('#numberfinder').val();
    var emailVal = $('#emailfinder').val();
    var phoneVal = $('#phfinder').val();
    $('.fr-header .fr-error').remove();
    
    if(numberVal === '' && emailVal === '' && phoneVal === ''){
      $('.finderResult').slideDown(300);
      $('.fr-header').append('<p class="fr-error" style="margin-top:10px;">Please enter your repair number and email address, or enter repair number and phone number.</p>')
      $(window).scrollTop($('.fr-header').offset().top - 400);
      return false;
    }  
    
    if(numberVal === ''){
      $('.finderResult').slideDown(300);
      $('.fr-header').append('<p class="fr-error" style="margin-top:10px;">Please also enter your repair number.</p>')
      $(window).scrollTop($('.fr-header').offset().top - 400);
      return false;
    }

    if(emailVal === '' && phoneVal === ''){
      $('.finderResult').slideDown(300);
      $('.fr-header').append('<p class="fr-error" style="margin-top:10px;">Please also enter your phone number or email address.</p>')
      $(window).scrollTop($('.fr-header').offset().top - 400);
      return false;
    } 
    // if(numberVal === ''){
    //   $('.finderResult').slideDown(300);
    //   $('.fr-header').append('<p class="fr-error" style="margin-top:10px;">Please also enter your repair number.</p>')
    //   $(window).scrollTop($('.fr-header').offset().top - 400);
    //   return false;
    // } 

    var form_data = 'SIRA='+ numberVal +'&SIEMAIL='+ emailVal +'&SIPHONE='+ phoneVal;
    $('.fr-error, .fr-result').remove();
    $.ajax({                 
      data: form_data,
      url: "https://cgi.briggs-riley.com/cgi/CGPBLMRI1", 
      method: "POST",   
      dataType: "json",
      success: function(response){        
        if(response.success){
          var result = response.success;
          $.each(result, function(key,val){
          	var resultTable = '<div class="fr-result">'+
              '<div class="fr-resultInner">'+
                '<div class="fr-resultCol">'+
                  '<table>'+                    
                    '<tr class="fr-repair">'+
                      '<td class="fr-dark">Repair no.</td>'+
                      '<td class="fr-light">' + val['Repair No.'] + '</td>'+
                    '</tr>'+
                    '<tr class="fr-consumer">'+
                      '<td class="fr-dark">Consumer</td>'+
                      '<td class="fr-light">' + val['Consumer'] + '</td>'+
                    '</tr>'+
                    '<tr class="fr-consumer-city">'+
                      '<td class="fr-dark">Consumer city/state</td>'+
                      '<td class="fr-light">' + val['Consumer City/State'] + '</td>'+
                    '</tr>'+
                    '<tr class="fr-consumer-phone">'+
                      '<td class="fr-dark">Consumer phone</td>'+
                      '<td class="fr-light">' + val['Consumer Phone'] + '</td>'+
                    '</tr>'+
                    '<tr class="fr-style">'+
                      '<td class="fr-dark">Style</td>'+
                      '<td class="fr-light">' + val['Style'] + '</td>'+
                    '</tr>'+                    
                  '</table>'+
                '</div>'+
                '<div class="fr-resultCol">'+
                  '<table>'+                       
                    '<tr class="fr-date-completed">'+
                      '<td class="fr-dark">Date completed</td>'+
                      '<td class="fr-light">' + val['Date Completed'] + '</td>'+
                    '</tr>'+
                    '<tr class="fr-statue">'+
                      '<td class="fr-dark">Status</td>'+
                      '<td class="fr-light">' + val['Status'] + '</td>'+
                    '</tr>'+
                    '<tr class="fr-tracking">'+
                      '<td class="fr-dark">Tracking</td>'+
                      '<td class="fr-light">' + val['Tracking'] + '</td>'+
                    '</tr>'+                    
                  '</table>'+
                '</div>'+
              '</div>'+
            '</div>';
            $('.fr-header').append(resultTable);
          });
          $('.finderResult').slideDown(300);
        }else{
          $('.finderResult').slideDown(300);
          $('.fr-header').append('<p class="fr-error" style="margin-top:10px;">' + response.error.error_message + '</p>')
        }
        $(window).scrollTop($('.fr-header').offset().top - 400);
      },
      error: function (response) {
       console.log(response);
      }      
    });
  });
  

  function statesUpdate() {
    var activeCountry = $('#rf-country').find('option:selected').val();
    //stateCountryJson();
    var states = $('#rf-country').find('option:selected').attr('data-provinces');
    if(states != '[]') {
      $('#rf-state').show();
      states = JSON.parse(states);
      var stateLen = states.length;
      $('#rf-state').find('option').remove();
      $('#rf-state').append('<option disabled>State</option>');
      for(i=0; i<stateLen;i++) {    
        $('#rf-state').append('<option>'+states[i][0]+'</option>');
      }
    }
    else {
      $('#rf-state').hide();
    }
  }
  
  function contactStatesUpdate() {
    var states = $('#cu_country').find('option:selected').attr('data-provinces');
    if(states != '[]') {
      $('#cu_state').show();
      states = JSON.parse(states);
      var stateLen = states.length;
      $('#cu_state').find('option').remove();
      $('#cu_state').append('<option>State</option>');
      for(i=0; i<stateLen;i++) {    
        $('#cu_state').append('<option value="'+states[i][0]+'">'+states[i][0]+'</option>');
      }
    }
    else {
      $('#cu_state').hide();
    }
  }
  
  if($('body').hasClass('page-repair-request')) {
//     statesUpdate();
  }
  
  if($('body').hasClass('page-contact')) {
    contactStatesUpdate();
    $('input[type=file]').on('change', function() {
      var fileName = $(this).val();
      if(fileName != '') {
        var fileIndex = fileName.lastIndexOf('\\');        
        if(fileIndex > 0) {
          fileName = fileName.substr(fileIndex+1);
          $('.cu-maxFile').text(fileName);
        }
      }
    });
  }
  
  
  
//   $('#rf-country').change(function() {
//     //statesUpdate();
//   });
  
  $('#cu_country').change(function() {
    contactStatesUpdate();
  });
  
  $('#rf-color').change(function() {
    if($(this).find('option:selected').text() != 'Color*') {
      $(this).removeClass('redBorder');
    } 
  });
  $('#rf-state').change(function() {
    if($(this).find('option:selected').text() != 'State*') {
      $(this).removeClass('redBorder');
    } 
  });

  var cgiEndpoint = "https://cgi.briggs-riley.com";
  $('#repairRequest').on('submit', function(e) {
    $('.loaderWrap').show();
    e.preventDefault();
    var form_data = jQuery("#repairRequest").serialize();
    form_data += '&form_key=ljX7FDGqDy4dUBQh';
    if($('#rf-color').find('option:selected').text() == "Color*") {
      $('#rf-color').addClass('redBorder');
      $('.buttonInfoGrid').find('.repairErrorMsg').remove();
      $('.buttonInfoGrid').append('<p class="repairErrorMsg">Please select a color*</p>');
      setTimeout(function() {
        $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
      },3000);
      $('.loaderWrap').hide();
    }
    else if($('#rf-state').find('option:selected').text() == "State*") {
      $('#rf-state').addClass('redBorder');
      $('.buttonInfoGrid').find('.repairErrorMsg').remove();
      $('.buttonInfoGrid').append('<p class="repairErrorMsg">Please select a state*</p>');
      setTimeout(function() {
        $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
      },3000);
      $('.loaderWrap').hide();
    }
    else {
      
    if($('#shipping_label').is(':checked')){
    	$.ajax({                 
          data: form_data,
          url: cgiEndpoint + "/cgi/cgpbsrrh1", 
          method: "POST",   
          dataType: "json",
          success: function(response){             
            if(response.error) {
              $('.loaderWrap').hide();
              $('.buttonInfoGrid').find('.repairErrorMsg').remove();
              $('.buttonInfoGrid').append('<p class="repairErrorMsg">'+response.error.error_message+'</p>');
              setTimeout(function() {
                $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
              },3000);
            }
            else {
              $('.loaderWrap').hide();
              $('.buttonInfoGrid').find('.repairMsg').remove();
              $('.buttonInfoGrid').append('<p class="repairMsg">Request Sent Successfully!</p>');
              setTimeout(function() {
                $('.buttonInfoGrid').find('.repairMsg').fadeOut(300);
              },3000);
              var raNumber = response.success.ra_number;
              var frameSrc = cgiEndpoint +  "/cgi/cgpbsrrrf?pmcno="+raNumber;
              $('#rr-iframe').attr('src',frameSrc);
              $('.repairRequestContent').hide();
              $('.rr-iframeWrap').show();   
              $('#SISTYLE, #rf-desc').val('');
              $('#rf-color').find('option').first().attr('selected',true);
              $('html,body').animate({'scrollTop': 0},300);
            }
          },
          error: function (response) {
            $('.loaderWrap').hide();
            $('.buttonInfoGrid').find('.repairErrorMsg').remove();
            $('.buttonInfoGrid').append('<p class="repairErrorMsg">Failed to send a message.</p>');
            setTimeout(function() {
              $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
            },3000);
          }
        });
    }else{     
      var ship_info = 'ship-to_info'; 
    	$.ajax({                 
          data: form_data,
          url: cgiEndpoint + "/cgi/cgpbsrrh1", 
          method: "POST",   
          dataType: "json",
          success: function(response){        
            if(response.error) {
              $('.loaderWrap').hide();
              $('.buttonInfoGrid').find('.repairErrorMsg').remove();
              $('.buttonInfoGrid').append('<p class="repairErrorMsg">'+response.error.error_message+'</p>');
              setTimeout(function() {
                $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
              },3000);
            }
            else {
              $('.loaderWrap').hide();
              $('#ra-number').text(response.success.ra_number);
              $('#description').text(response.success.repair_description);
              $('#style_no').text(response.success.style_info.Style);
              $('#color_name').text(response.success.style_info.Color);
              $('#cust_name').text(response.success.customer_info.Name);
              $('#cust_addr1').text(response.success.customer_info['Address 1']);
              $('#cust_addr2').text(response.success.customer_info['Address 2']);
              $('#cust_city').text(response.success.customer_info.City);
              $('#cust_state').text(response.success.customer_info.State);
              $('#cust_zip').text(response.success.customer_info.Zip);
              $('#cust_phone').text(response.success.customer_info.Phone);
              $('#cust_mail').text(response.success.customer_info.Email);
              $('#ship_name').text(response.success['ship-to_info'].Name);
              $('#ship_addr1').text(response.success['ship-to_info']['Address 1']);
              $('#ship_addr2').text(response.success['ship-to_info']['Address 2']);
              $('#ship_city').text(response.success['ship-to_info'].City);
              $('#ship_state').text(response.success['ship-to_info'].State);
              $('#ship_zip').text(response.success['ship-to_info'].Zip);
              $('#ship_phone').text(response.success['ship-to_info'].Phone);
              $('#ship_mail').text(response.success['ship-to_info'].Email);
              $('.pr-response').addClass('showResponse');
              $('#SISTYLE, #rf-desc').val('');
              $('#rf-color').find('option').first().attr('selected',true);
              $('html,body').animate({'scrollTop': 0},300);
            }
          },
          error: function (response) {
            $('.loaderWrap').hide();
            $('.buttonInfoGrid').find('.repairErrorMsg').remove();
            $('.buttonInfoGrid').append('<p class="repairErrorMsg">Failed to send a message.</p>');
            setTimeout(function() {
              $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
            },3000);
          }
        });
    }
  }
  });  
  if($('body').hasClass('page-Submit')) {
    document.getElementById("pr-response").addEventListener("click", function() {
      var printContents = document.getElementById('pr-response').innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
   
});
  }
  
  
  $('#customerCareForm').on('submit', function(e) {
    e.preventDefault();
    var currWindowPos = $(window).scrollTop();
    var tobeScroll = currWindowPos+200;
    var confirmMail = $('#cu_mail').val();
    var actualMail = $('#mail').val();
    if(confirmMail != actualMail) {
      $('.confirmEmailWrap').addClass('confirmEmailError').append('<p class="mailError">Confirm email is not same.</p>');
      $('.confirmEmailWrap').find('input').val('');
      setTimeout(function() {
        $('.confirmEmailWrap').removeClass('confirmEmailError').find('.mailError').remove();
      },3000);
    }
    else {
      if($('#cu_help').val() == 'Inquiry About*') {
        $('.buttonInfoGrid').find('.repairErrorMsg').remove();
        $('.buttonInfoGrid').append('<p class="repairErrorMsg">Please Complete Captcha</p>');
        $('html,body').animate({'scrollTop':tobeScroll},300);
        setTimeout(function() {
          $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
        },3000);
      }
      /*
      else if($('#cu_state').val() == 'State*') {
        $('.buttonInfoGrid').find('.repairErrorMsg').remove();
        $('.buttonInfoGrid').append('<p class="repairErrorMsg">Please select from states</p>');
        $('html,body').animate({'scrollTop':tobeScroll},300);
        setTimeout(function() {
          $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
        },3000);
      }
      */
      
      else if(grecaptcha.getResponse().length == 0) {
        $('.buttonInfoGrid').find('.repairErrorMsg').remove();
        $('.buttonInfoGrid').append('<p class="repairErrorMsg">Please check the Captcha</p>');
        $('html,body').animate({'scrollTop':tobeScroll},300);
        setTimeout(function() {
          $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
        },3000);
      }
      else {
        //$('input[name=cu_radio]:checked').val(1);
        
        var form = $('#customerCareForm');

		// Create an FormData object 
        var data = new FormData();

		// If you want to add an extra field for the FormData
        data.append("cu_help", $('#cu_help').val());
        data.append("fname", $('#fname').val());
        data.append("lname", $('#lname').val());
        data.append("phone", $('#phone').val());
        data.append("orderNo", $('#orderNo').val());
        data.append("address1", $('#address1').val());
        data.append("address2", $('#address2').val());
        data.append("cu_city", $('#cu_city').val());
        data.append("zip", $('#zip').val());
        data.append("cu_country", $('#cu_country').val());
        data.append("cu_state", $('#cu_state').val());
        data.append("mail", $('#mail').val());
        data.append("cu_radio", $('input[name="cu_radio"]:checked').val());
        data.append("style1", $('#style1').val());
        // Cleaning up non-standard apostrophes in the comments section
        let comment_str = $('#comments').val(); 
        let clean_comment_str = comment_str.replace(/[’‘´`’‘]/g, "'").replace(/[áạàảãăắặằẳẵâấậầẩẫ]/g,'a').replace(/[ÁẠÀẢÃĂẮẶẰẲẴÂẤẬẦẨẪ]/g,'A').replace(/[éẹèẻẽêếệềểễ]/g,'e').replace(/[ÉẸÈẺẼÊẾỆỀỂỄ]/g,'E').replace(/[íịìỉĩ]/g,'i').replace(/[ÍỊÌỈĨ]/g,'I').replace(/[óọòỏõôốộồổỗơớợờởỡ]/g,'o').replace(/[ÓỌÒỎÕÔỐỘỒỔỖƠỚỢỜỞỠ]/g,'O').replace(/[úụùủũưứựừửữ]/g,'u').replace(/[ÚỤÙỦŨƯỨỰỪỬỮ]/g,'U').replace(/[ýỵỳỷỹ]/g,'y').replace(/[ÝỴỲỶỸ]/g,'Y').replace(/[đ]/g,'d').replace(/[Đ]/g,'D').replace(/[ñ]/g,'n').replace(/[Ñ]/g,'N').replace(/[¿]/g,'?').replace(/[¡]/g,'i').replace(/[“]/g,'"').replace(/[”]/g,'"');

        data.append("comments", clean_comment_str);
        data.append("cu_file", $('#cu_file')[0].files[0]); 
        
        var fileType = $('#cu_file')[0].files[0];
        if(fileType) {
          var fileSize = fileType.size;
        }
        
        
        if(fileType && fileSize > 1500000) {
          $('.cu-maxFile').addClass('redError').text('max file size for image is 1.5 mb');          
        }
        else {
          var form_data = jQuery("#customerCareForm").serialize();
          $('.buttonInfoGrid input').attr('disabled',true);
          $.ajax({                 
            data: data,
            url: "https://productreg.briggs-riley.com/api/send-mail",
            method: "POST",
            mimeType: 'multipart/form-data',
            dataType: "json",
            processData: false,  // Important!
            contentType: false,
            success: function(response, textStatus, jQxhr ){                 
              $('.buttonInfoGrid').append('<p class="repairMsg">'+response.message+'</p>');
              $('html,body').animate({'scrollTop':tobeScroll},300);
              setTimeout(function() {
                $('.buttonInfoGrid').find('.repairMsg').fadeOut(300);
              	$('.buttonInfoGrid input').removeAttr('disabled');
              },5000);
              document.getElementById('customerCareForm').reset();
              $('.cu-maxFile').text('max file size for image is 1.5 mb');
            },
            error: function (response) {
              console.log('error');
              console.log(response.status);
              $('.buttonInfoGrid input').removeAttr('disabled');
              $('.buttonInfoGrid').find('.repairErrorMsg').remove();
              $('.buttonInfoGrid').append('<p class="repairErrorMsg">'+response.message+'</p>');
              $('html,body').animate({'scrollTop':tobeScroll},300);
              setTimeout(function() {
                $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
              },3000);
              console.log("=======");
              console.log(response);
            }

          });
        }
      }
    }
  });
  
  
 $('#productRegistrationForm').on('submit', function(e) {
    e.preventDefault();
   $('.loaderWrap').show();
    var currWindowPos = $(window).scrollTop();
    var tobeScroll = currWindowPos+200;
    //$('input[name=is_addition_register]:checked').val(1);
    //$('input[name=is_ask_more]:checked').val(1);
   
   if ($('#date_of_purchase').val() == '' || $('#date_of_purchase').val() == 0) {
     $('.loaderWrap').hide();
     $('.buttonInfoGrid').find('.repairErrorMsg').remove();
     $('.buttonInfoGrid').append('<p class="repairErrorMsg">Please select a date</p>');
     $('html,body').animate({'scrollTop':tobeScroll},300);
     setTimeout(function() {
       $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
     },3000);
   }
   else if ($('#style_num').val() == '' || $('#style_num').val() == 0) {
     $('.loaderWrap').hide();
     $('.buttonInfoGrid').find('.repairErrorMsg').remove();
     $('.buttonInfoGrid').append('<p class="repairErrorMsg">Please enter Style Number</p>');
     $('html,body').animate({'scrollTop':tobeScroll},300);
     setTimeout(function() {
       $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
     },3000);
   }
   else if ($('#serial_num').val() == '' || $('#serial_num').val() == 0) {
     $('.loaderWrap').hide();
     $('.buttonInfoGrid').find('.repairErrorMsg').remove();
     $('.buttonInfoGrid').append('<p class="repairErrorMsg">Please enter Serial Number</p>');
     $('html,body').animate({'scrollTop':tobeScroll},300);
     setTimeout(function() {
       $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
     },3000);
   }
   else {
     var form_data = jQuery("#productRegistrationForm").serialize();
     var dateVal = $('#productRegistrationForm').val();
     $.ajax({                 
       data: form_data,
       url: "https://productreg.briggs-riley.com/api/registration", 
       method: "POST",   
       dataType: "json",
       success: function(response){
         var statusCode = response.status;
         if(statusCode == true || statusCode == 200) {
           window.location.href= "/account";
         }
         else {
           $('.loaderWrap').hide();
           $('.buttonInfoGrid').append('<p class="repairMsg">'+response.message+'</p>');
           $('html,body').animate({'scrollTop':tobeScroll},300);
           setTimeout(function() {
             $('.buttonInfoGrid').find('.repairMsg').fadeOut(300);
           },3000);
         }

       },
       error: function (response) {
         $('.loaderWrap').hide();
         console.log(response.data);
         $('.buttonInfoGrid').append('<p class="repairErrorMsg">'+response.responseJSON.message+'</p>');
         $('html,body').animate({'scrollTop':tobeScroll},300);
         setTimeout(function() {
           $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
         },3000);
         console.log("=======");
         console.log(response);
       }

     });

   }
  });
  
  
  if($('body').hasClass('page-product-listing') || $('body').hasClass('customers-account')) {
    var email_id = $('#email_id').val();
    $.ajax({                 
      data: {email: email_id},
      url: "https://productreg.briggs-riley.com/api/list_registration", 
      method: "GET",   
      dataType: "json",
      success: function(response){
        var totData = response.data.length;
        if(totData >0 ) {
       // console.log('totData: '+totData);        
        for(i=0;i<totData;i++) {
          var resultedDate = response.data[i].register_date;
          var formattedDate = resultedDate.replace(/-/g,'/');
          if(response.data[i].serial_num2 != '' && response.data[i].serial_num2 != null) {
            var totalSerial = response.data[i].serial_num+', '+response.data[i].serial_num2;
          }          
          else {
            var totalSerial = response.data[i].serial_num;
          }
          
          if(response.data[i].style_num2 != '' && response.data[i].style_num2 != null) {
            var totalStyle = response.data[i].style_num+', '+response.data[i].style_num2;
          }          
          else {
            var totalStyle = response.data[i].style_num;
          }
          
          $('.prTableWrap table').append('<tr><td class="t-style tDark">'+totalStyle+'</td><td class="t-serial tDark">'+totalSerial+'</td><td class="t-date tDark">'+formattedDate+'</td></tr>');
        }
        }
        else {
          $('.prTableWrap').append('<p>'+response.message+'</p>');
        }
        //$('.prTableWrap table').append('<tr><td></td></tr>');
      },
      error: function (response) {
        console.log(response);
      }

    });
  }
  
  if($('body').hasClass('product')) {
    $('.featuresContent ul li').each(function() {
      if($(this).text().trim() == '') {
        $(this).remove();
      }
    });
  }
  
  
  $('.additionCheck').on('change', function() {
    if($(this).is('.additionCheckNo')) {
      $('#serialAdd, #styleAdd').val('');
    }
  });
  
  
  
});

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/
Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;
    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;
    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify.optionsMap[key];
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').not('.soldout').first().prev('input[type="radio"]').attr('checked', true);
};

Shopify.linkOptionSelectors = function(product, parent) {
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
        Shopify.optionsMap['root'].push(variant.option1);
        Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(parent + " .single-option-selector:eq(0)").change(function() {
      Shopify.updateOptionsInSelector(1, parent);
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
    // When there is an update in the second dropdown.
    $(parent + " .single-option-selector:eq(1)").change(function() {
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
};

//Used for cart functionality
function htmlEncode(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

//Check if device is touch-enabled
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){var o;return o=Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e,o+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_apostrophe_separator":r=i(t,2);break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};

$(document)
  .on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.select(blockId, $parentSection);
    }

    if($parentSection.hasClass('page-details-section')){
      if($('.map-section').length) {
        mapFunction.init();
      }
    }

    if ($parentSection.hasClass('cart-section')){
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('product-template')){
      
    }

    utils.resizeActionButtons();

});

$(document)
  .on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.deselect($parentSection)
    }

});

$(document)
  .on('shopify:section:reorder', function(e){

    utils.pageBannerCheck();

});

$(document)
  .on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    utils.pageBannerCheck();

    

    if ($parentSection.hasClass('image-gallery-section')){
      gallery.init($parentSection);
    }

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {

        social.twitter();

        var $target = $(this).find(".js-instafeed");
        instagram.loadContent({
          el: $target,
          clientID: $target.data('client-id'),
          limit: $target.data('count'),
          column: $target.data('column')
        });
      });
    }

    if ($parentSection.hasClass('faq-section')){
      faqAccordion.init();
    }

    if ($parentSection.hasClass('cart-section')){
      cart.init();
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('featured-promotions-section')){
      featuredPromotions.init();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.init();
    }

    
      if ($parentSection.hasClass('search-section')){
        searchAutocomplete.init();
      }
    


    if ($parentSection.hasClass('testimonial-section')){
      testimonial.init();
    }

    if ($parentSection.hasClass('featured-products-section')){
      productPage.initializeQuantityBox();
      productPage.productSwatches();
      productPage.init();
      
    }

    if($parentSection.hasClass('map-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.init();
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.init();
    }

    if ($parentSection.hasClass('recently-viewed__section')){
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-template')){
      productPage.init();
      productPage.productSwatches();
      productPage.relatedProducts();
      recentlyViewed.init();
      
    }

    if ($parentSection.hasClass('article-template-section')){
      if(window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
      }
    }

    if ($parentSection.hasClass('collection-template-section')){
      collectionSidebarFilter.init();
    }

    if($parentSection.hasClass('contact-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('search-template-section')){
      
        searchAutocomplete.init();
      
      collectionSidebarFilter.init();
    }

    if ($parentSection.hasClass('header-section')){
      header.init();
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      mapFunction.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
    }
});


$(document)
  .on('shopify:section:unload', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('header-section')){
      header.unload($target);
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.unload($target);
    }

    if ($parentSection.hasClass('testimonial-section')){
      testimonial.unload($target);
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('search-section')){
      searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('product-template')){
      productPage.unload($target);
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('product-details-section')) {
      videoSection.unload($target);
    }

});

$(document)
  .on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {
        social.twitter();
      });
    }

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      setTimeout(function() {
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
        header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
      }, 10);
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.unload($parentSection);
      featuredCollectionSection.init();
    }

    utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document)
  .on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }
});

$(document).on('click', '.range-size-wrapper .range-size', function() {
  
	$(this).parents('.range-size-wrapper').find('.range-size-popup').fadeToggle();
	return false;
});

$(document).on('click', '.donation-action', function() {
  var selected_variant = $(this).parents('.donation-wrapper').find('.donation-options').val();
  var _this = $(this);

  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: {
      id: selected_variant
    },
    beforeSend: function() {
      _this.attr('disabled', 'disabled').addClass('disabled');
      _this.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
    },
    success: function(itemData) {
      _this.find('.checkmark').addClass('checkmark-active');

      window.setTimeout(function(){
        _this.removeAttr('disabled').removeClass('disabled');
        _this.find('.checkmark').removeClass('checkmark-active');
        _this.find('span').removeClass('zoomOut').addClass('fadeInDown');
      }, 1000);
      
      location.reload();
    },
    error: function(XMLHttpRequest) {
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;
      $('.warning').remove();

      var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
      _this.after(warning);
      _this.removeAttr('disabled').removeClass('disabled');
      _this.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
    }
  });
  
  return false;
});

$(document).on('click', '.cs_accordion-wrapper .cs_accordion-target', function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active').find('button').attr('aria-expanded', 'false');
    $('.cs_accordion-wrapper .cs_accordion-content').slideUp();
  } else {
    $('.cs_accordion-wrapper .cs_accordion-target').each(function (i, elem) {
      $(elem).removeClass('active').find('button').attr('aria-expanded', 'false')
    });
    $('.cs_accordion-wrapper .cs_accordion-content').hide();
    $(this).addClass('active').find('button').attr('aria-expanded', 'true');
    $(this).parents('.cs_accordion-box').find('.cs_accordion-content').slideDown(500);
  }

  return false;
});

$(document).on('click', '.custom-compare-link', function() {
  	$('#sa_ca_wrapper .ca_flap.ca_tab').trigger('click');
  	return false;
});

$(document).on('click', '.compare-controls .ca_Rmvall', function() {
  	$('.custom-compare-link').hide();
});

function closeMonogramPopup(action){ 
  $('.monogram-error').remove();
  var text = $('#monogram-input').val();   
  if(action === 'add'){
    if(text === ''){
      $('#monogram-input').addClass('error');
      return false;
    }else if(!isValid(text)){
      $('#monogram-input').addClass('error');
      $('<span class="monogram-error">Invalid</span>').insertAfter('#monogram-input');
      return false;
    }else if(text.length > 3){
      $('#monogram-input').addClass('error');
      $('<span class="monogram-error">Only 3 characters allowed</span>').insertAfter('#monogram-input');
      return false;
    }else{
      $('#monogram-input').removeClass('error');      
      $('.custom-monogram-link').text(text + ' (Edit)');
      $('.custom-monogram-popup, .custom-monogram-overlay').hide();
    }
  }else if(action === 'delete'){
    $('#monogram-input').val('');
    $('#monogram-input').removeClass('error');
    $('.custom-monogram-link').text('Add your initials');
    $('.custom-monogram-popup, .custom-monogram-overlay').hide();
  }else{    
    $('.custom-monogram-popup, .custom-monogram-overlay').hide();
  }
  if(text === ''){
    $('#monogram-input').prop('disabled', true);
  }
}

$('.custom-monogram-link').on('click', function() {
  	$('.custom-loader-overlay').show();
    $('.custom-loader').show();
    $('.custom-monogram-popup').find('.custom-monogram-popup-close').attr('aria-label','close');
    $('.custom-monogram-popup').find('.custom-monogram-popup-close').focus();
    if($('.custom-monogram-popup').attr('aria-modal') != 'true') {
      $('.custom-monogram-popup').attr('role','dialog');
      $('.custom-monogram-popup').attr('aria-modal','true');
      $('.custom-monogram-popup').attr('aria-label','Personalize your Product name');
    }
    $('.custom-monogram-popup-form input').removeAttr('disabled');
    $('.custom-loader-overlay').hide();
    $('.custom-loader').hide();
    $('.custom-monogram-popup, .custom-monogram-overlay').show();

  	//return false;
});

$('#monogram-input').on('keypress keyup', function(e){
  var key = event.key;
  if (!isValid(key)) {
      e.target.value = e.target.value.replace(/[^a-z0-9\s]/gi, '');
      event.preventDefault();
      return false;
  }else{
    e.target.value = e.target.value.toUpperCase();
  }  
});

function isValid(str) {
  return !/[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(str);
}

//Click handler on Add monogram button
$('.add_monogram').on('click', function(){
  closeMonogramPopup('add');
});

//Click handler on Delete monogram button
$('.delete_monogram').on('click', function(){
  closeMonogramPopup('delete');
});

//Click handler on cross button on popup
$('.custom-monogram-popup-close').on('click', function() {
  closeMonogramPopup();
});

$(document).on('focus', '#closeRefocus', function(){
	$('.custom-monogram-popup-close').focus();
});

$(document).on('keydown blur', '.custom-monogram-popup.has-form', function(e){
  if (e.shiftKey && e.keyCode === 9) {
  	return false;
  }
});

$(document).on('click', '.custom-monogram-overlay', function() {
  closeMonogramPopup();
  return false;
});


$(document).keyup(function(e) { 
    if (e.keyCode === 27 && $('.custom-monogram-popup:visible').length > 0) { 
      closeMonogramPopup();
    } 
});


$(document).on('click', '.details-modal', function(){
  $('.custom-monogram-overlay, .custom-shipping-popup').fadeIn();	
})

$(document).on('click', '.custom-shipping-popup-close', function(){
  $('.custom-monogram-overlay, .custom-shipping-popup').fadeOut();
})

var checkArray = [2959, 2960, 2961, 2963];
var tradeinKey = 2975;


$(document).on('change', '#stockist-widget .js-stockist-filter-custom-select', function() {
    const $selectedOptions = $(this).find('option:selected');
    const selectedKey = $selectedOptions.data('key');
    const showAll = $selectedOptions.data('stockist-all');
    const $stockistSearchFilterCheckbox = $('#stockist-widget .stockist-search-filter-checkbox');
    $(this).find('option').removeAttr("selected")
  
  	if(!selectedKey && showAll) { 
      const $listOfCheckboxWrap = document.querySelectorAll('#stockist-widget .stockist-search-filter-checkbox');
      $listOfCheckboxWrap.forEach(function (wrap) {
        if (wrap.style.display === 'none') {
          const $input = wrap.querySelector('input');
          if ($input.checked) {
            $input.closest('label').click()
          }
        }
      })
    } else {
      checkArray.map(function(val) {
        var inputEl = $stockistSearchFilterCheckbox.find('input[value='+val+']');
        inputEl.prop('checked', false);
        inputEl.parents('.stockist-search-filter-checkbox').removeClass('stockist-selected');
      });
      
      $stockistSearchFilterCheckbox.find('input[value='+selectedKey+']').parents('label').trigger('click');
    }
    $selectedOptions.attr('selected', true)
  	return false;
});

if($('body').hasClass('page-store')) {

  window.stockistWidgetLoaded = function () {
    var imageArray = ["//costco.briggs-riley.com/cdn/shop/t/29/assets/bag_1_icon.svg?v=67247076047045686271774556464", "//costco.briggs-riley.com/cdn/shop/t/29/assets/bag_2_icon.svg?v=50453603555065534141774556464", "//costco.briggs-riley.com/cdn/shop/t/29/assets/bag_3_icon.svg?v=5941739865064843031774556464", "//costco.briggs-riley.com/cdn/shop/t/29/assets/bag_4_icon.svg?v=117431309876826558241774556464"];
    var counter = 0;

    $('.stockist-search-filters').css('opacity', 0);

    var checkEl = $('.stockist-search-filter-checkboxes .stockist-search-filter-checkbox');

    var selectFilter = '<fieldset class="stockist-filter-custom-select"><label for="stockist-select-list" class="stockist-filter-custom-select-filter">Filter</label><select id="stockist-select-list" class="stockist-filter-custom-select-list js-stockist-filter-custom-select"><option class="stockist-filter-custom-option" selected data-stockist-all="true">Show All</option>';

    checkEl.each(function (i) {
      var _this = $(this);

      if (i > 1) {
        _this.hide();
      }

      var currentKey = _this.find('input').val();

      if (jQuery.inArray(Number(currentKey), checkArray) !== -1) {
        var labelText = _this.find('label').text();

        selectFilter += '<option class="stockist-filter-custom-option" data-label="${labelText}" data-key="${currentKey}" data-bg-test="${imageArray[counter]}" >${labelText}</option>';
        counter = counter + 1;
      }
    });

    selectFilter += '</select></fieldset>';

    $('.stockist-search-filters').append(selectFilter);

    $('.stockist-search-filters').css('opacity', 1);
  }
} else {

  	window.stockistWidgetLoaded = function() {

        $('.stockist-search-filters').hide();
      
      	$('.stockist-result-list').css('opacity', 0);

      	setTimeout(function() {
          	$('#stockist-widget .stockist-search-filter-checkbox').find('input[value='+tradeinKey+']').parents('label').trigger('click');
          	$('.stockist-result-list').css('opacity', 1);
        },1000);
    }
}

$(window).on("load", function() {   
   
  //if($('body').hasClass('page-lookbook')) {
    if($(window).width() > 1024) {
      function loadApp() {
        var bookWidth = 2*10*(window.innerHeight)/13;
        var bookHeight = window.innerHeight;
        $("#flipbook").turn({
          // Width

          width:bookWidth,       //1100

          // Height

          height:bookHeight,       //715

          // Elevation

          elevation: 50,

          // Enable gradients

          gradients: true,

          // Auto center this flipbook

          autoCenter: true
        });
      }

      yepnope({
        test : Modernizr.csstransforms,
        yep: "//costco.briggs-riley.com/cdn/shop/t/29/assets/turn.js?v=19493523255364624331774556464",
        nope: "//costco.briggs-riley.com/cdn/shop/t/29/assets/turn.html4.min.js?v=92748171859993084991774556464",
        both: "//costco.briggs-riley.com/cdn/shop/t/29/assets/basic.css?v=41794652606607296701774556464",
        complete: loadApp
      });
    }
    
  $('.lookbookContainer').css('visibility','visible');
  $(document).on('click', 'a[href="#lookbook"]', function() {
    console.log('hiii');
    $('.lookbook-popup').fadeIn(300);
    $('.dropdown_link .open').click();
    if($(window).width() < 1024) {
      $('.lookBookSlider').slick({
        dots: false,
        arrows: true,
        prevArrow: true,
        prevArrow:'<span class="t_arrow t_PrevArrow"></span>',
        nextArrow: true,
        nextArrow:'<span class="t_arrow t_NextArrow"></span>',
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  });
  $(document).on('click', '.lb-close', function() {
    $('.lookbook-popup').fadeOut(300);
    $('.lookBookSlider').slick("unslick");
  });
  
  
  var lookbookPages = $('.lookBookSlide').length;
  
  $(document).on('click', '.lb-arrow', function() {    
    if($(this).is('.lb-prev')) {
      $("#flipbook").turn("previous");      
    }
    else {
      $("#flipbook").turn("next");
    }
    
    var pageVal = $("#flipbook").turn("page");
    if(pageVal == 1) {
      $('.lb-prev').addClass('lb-disabled').siblings('.lb-next').removeClass('lb-disabled');
    }
    if(pageVal >1 && pageVal < lookbookPages) {
      $('.lb-prev').removeClass('lb-disabled').siblings('.lb-next').removeClass('lb-disabled');
    }
    else {
      $('.lb-prev').removeClass('lb-disabled').siblings('.lb-next').addClass('lb-disabled');
    }
  });
  
  //}
  
  $(document).on('click', '.pas-link', function(e) {
    e.preventDefault();
    if(!$('.specs-target').hasClass('active')) {
      $('.specs-target').click();
      var currScroll = $(window).scrollTop();
      $('html,body').animate({'scrollTop': currScroll+200},300);
    }    
  });
  
  $(document).on('click', '.removeCartItem', function() {
    var _this = $(this);
    var parent = _this.closest('.cart_content_info');
    var gp_id = parent.find('.quantity[gp_id]').attr('gp_id');
    $('#cart_form .subtotal').css('pointer-events', 'none');
    
    if(typeof gp_id != 'undefined'){
      parent.find('.quantity[gp_id]').val(0).change();
    }else{
      var lineIndex = $(this).attr('data-index');
      $.ajax({                 
        data: { 
          quantity: 0,
          line: lineIndex
        },
        url: "/cart/change.js", 
        method: "POST",   
        dataType: "json",
        success: function(response){
          window.location.href = "/cart";
        }            
      });
    }    
  });
  
  $(document).on('change', '#cu_help', function() {
    var selectedOpt = $(this).find('option:selected').text();
    if(selectedOpt == 'Order Status') {
      $('#orderNo').show().attr('required',true);  
      $('#address1').removeAttr('required',true);
      $('#address1').attr('placeholder','Address1(Optional)');
      $('#style1').removeAttr('required');
      $('#style1').attr('placeholder','Style#');      
      $('#phone').attr('required', true);
      $('#phone').attr('placeholder','Phone*');
      $('#zip').removeAttr('required');
      $('#zip').attr('placeholder','Zip/Postal code(Optional)');      
    }
    else if(selectedOpt == 'Product Information') {
      $('#orderNo').hide().removeAttr('required');
      $('#orderNo').val('');
      $('#address1').removeAttr('required',true);
      $('#address1').attr('placeholder','Address1(Optional)');
      $('#style1').removeAttr('required');
      $('#style1').attr('placeholder','Style#');
      $('#phone').attr('required', true);
      $('#phone').attr('placeholder','Phone*');
      $('#zip').removeAttr('required');
      $('#zip').attr('placeholder','Zip/Postal code(Optional)');
    
    }
    else if(selectedOpt == 'Lifetime Warranty / Repair Inquiry') {
      $('#orderNo').hide().removeAttr('required');
      $('#orderNo').val('');
      $('#address1').attr('required',true);
      $('#address1').attr('placeholder','Address1*');
      $('#style1').attr('required',true);
      $('#style1').attr('placeholder','Style#*');
      $('#phone').attr('required', true);
      $('#phone').attr('placeholder','Phone*');
      $('#zip').removeAttr('required');
      $('#zip').attr('placeholder','Zip/Postal code(Optional)');
      
    }
    else if(selectedOpt == 'Registration Inquiry') {
      $('#orderNo').hide().removeAttr('required');
      $('#orderNo').val('');
      $('#address1').removeAttr('required',true);
      $('#address1').attr('placeholder','Address1(Optional)');
      $('#style1').attr('required',true);
      $('#style1').attr('placeholder','Style#*');
      $('#phone').attr('required', true);
      $('#phone').attr('placeholder','Phone*');
      $('#zip').removeAttr('required');
      $('#zip').attr('placeholder','Zip/Postal code(Optional)');
    }
    else if(selectedOpt == 'Find a Retailer') {
      $('#orderNo').hide().removeAttr('required');
      $('#orderNo').val('');
      $('#address1').removeAttr('required',true);
      $('#address1').attr('placeholder','Address1(Optional)');
      $('#style1').removeAttr('required');
      $('#style1').attr('placeholder','Style#');
      $('#phone').removeAttr('required');
      $('#phone').attr('placeholder','Phone');
      $('#zip').attr('required', true);
      $('#zip').attr('placeholder','Zip/Postal code*');
    }
    else {
      $('#orderNo').hide().removeAttr('required');
      $('#orderNo').val('');
      $('#address1').removeAttr('required',true);
      $('#address1').attr('placeholder','Address1(Optional)');
      $('#style1').removeAttr('required');
      $('#style1').attr('placeholder','Style#');
      $('#phone').attr('required', true);
      $('#phone').attr('placeholder','Phone*');
      $('#zip').removeAttr('required');
      $('#zip').attr('placeholder','Zip/Postal code(Optional)');
    }
  });
  
  function galleryHeight() {
    var verticalNavHeight = $('.product_section .product_gallery_nav').outerHeight();
    var slideLen = $('.flickity-slider .gallery-cell').length;
    var galleryArray = [];
    for(i=0;i<slideLen;i++) {
      var galleryHeight = $('.flickity-slider .gallery-cell').eq(i).outerHeight();
      galleryArray.push(galleryHeight);
    } 
    var galleryMax = Math.max(galleryArray);
    $('.product_section .product_gallery').addClass('product_jsHeight');
    $('.product_section .product_gallery').outerHeight(galleryMax);
  }
  //galleryHeight();
  $(window).resize(function() {
    //$('.product_section .product_gallery').removeClass('product_jsHeight');
    //$('.product_section .product_gallery').outerHeight('auto');
    //galleryHeight();
  });
  $('a.dropdown_link--vertical').on('click', function() {
    //alert('clicked');
  });
  $(document).keypress(function(event){
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if(keycode == '13'){
      //alert($(document).find('a:active').length);   
    }
  });
  
  /*============================================Menu open on press enter key============================================*/
  
  function itemsClose(attr) {
    if (attr.parentNode.className.includes("sublink")) {
      if (attr.parentNode.className.includes("open")) {
        attr.parentNode.classList.remove("open");
      	attr.parentNode.classList.remove("active_link");
      }
      else {
        attr.parentNode.classList.add("open");
      	attr.parentNode.classList.add("active_link");
      }      
    }
    else if(attr.parentNode.className.includes("has-child")) {
      attr.parentNode.className= "has-child open";
      attr.setAttribute('aria-expanded', "true");
    }
    else if (attr.parentNode.className.includes("cart_container")) {
      if(window.innerWidth >= 1024) {
        attr.parentNode.className = "cart_container active_link";
      }
      attr.setAttribute('aria-expanded', "true");
    } 
    else {      
        attr.parentNode.classList.remove("open");
      	attr.parentNode.classList.remove("active_link");
        attr.setAttribute('aria-expanded', "false");
      }
  }
  
  var menuItems = document.querySelectorAll('.vertical-menu li.sublink, li.has-child, .cart_container');
  Array.prototype.forEach.call(menuItems, function(el, i){
    el.querySelector('a').addEventListener("click",  function(event){
      itemsClose(this);
      event.preventDefault(); 
      return false;
    });
  });
  
});

$(document).ready(function() {
   $('.vertical-menu li.sublink').hover(
    function() {
      console.log('hover in');
      $( this ).addClass( "open" );
    }, function() {
      console.log('hover out');
      $( this ).removeClass( "open" );
    }
  );

      /*==============================Features modal on the collection pages==================================*/
  $(document).on('click', '.pbf-button-modal', function(e) {
    e.preventDefault();
    if($(this).parents('.collection').find('div').hasClass('featurePopup')) {      
      $('.featurePopup').fadeIn(300);
      $('html,body').css('overflow','hidden');
    }
  });
  $(document).on('click', '.featureClose', function() {
    $('.featurePopup').fadeOut(300);
    $('html,body').css('overflow','auto');
  });

    /*==============================================Clear Cart on Thnakyou Page==============================================*/
    if($('body').hasClass('page-thankyou')) {
      var cartCount = $('header .icon-cart.mini_cart.dropdown_link:visible').find('.cart_count').text();
      if( cartCount != 0) {
        $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          success: function(){
            $('header .icon-cart.mini_cart.dropdown_link:visible').find('.cart_count').text(0);
            $('.cart_content').find('form').addClass('hidden');
            $('.cart_content .js-empty-cart__message').removeClass('hidden');
            $('.page-thankyou .cart_count').css('opacity','1');
          },
          dataType: 'json'
        });
      }
    }

  $(document).on('click', '.product-video-thumb', function() {
    var videoId = $(this).attr('data-vidId');
    var videoSrc = 'https://www.youtube.com/embed/'+videoId;
    var $videoOverlay = $('.videosOverlayWrap');
    $('.videosOverlayWrap .videosOverlay iframe').attr('src',videoSrc);
    $videoOverlay.fadeIn(300);
    $videoOverlay.addClass('videosOverlayWrap-open');
    $('button.videoClose').focus();
    $('.videoClose').each(function (i, item) {
      $(item).attr('data-close-video-id', videoId)
    });
  });
    
  $(document).on('click', '.videoClose', function() {
    let id = $(this).attr('data-close-video-id')
    $('.videoClose').each(function (i, item) {
      $(item).attr('data-close-video-id', '')
    });
    $('.videosOverlayWrap').removeClass('videosOverlayWrap-open');
    $(this).parents('.videosOverlayWrap').fadeOut(300);
    $(this).parents('.videosOverlayWrap').find('.videosOverlay iframe').attr('src','');
    setTimeout(function () {
      $('[data-vidId='+id+']').focus();
    }, 300)
  });

  
  $(document).on('keydown', function (event) {
    const  focusableElements = 'button, iframe, [tabindex]:not([tabindex="-1"])';
    const modal = document.querySelector('.videosOverlayWrap'); // select the modal by it's id
    if (!modal) return;
    const firstFocusableElement = modal.querySelectorAll(focusableElements)[0];
    const focusableContent = modal.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
    const modalIsOpen = $('.videosOverlayWrap').hasClass('videosOverlayWrap-open');
    
      if (event.key === 'Escape' && modalIsOpen) {
        $('button.videoClose').click();
      } else if (event.key === 'Tab' && modalIsOpen) {
        if (event.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            event.preventDefault();
          }
        } else {
          let href = $(event.target).prop('href');
          if (href && href.indexOf('javascript:void(0);') > -1) {
            firstFocusableElement.focus(); 
            event.preventDefault();
          }
        }
      }
    
  });


  /* 
 if($(window).width() > 1024) {
   $('.vertical-menu .sublink a, .rightMenuWrap li.has-child a, .mini_cart.dropdown_link').on('mouseover', function() {     
     $(this).attr('aria-expanded', true);
   });
   $('.vertical-menu .sublink a, .rightMenuWrap li.has-child a, .mini_cart.dropdown_link').on('mouseout', function() {
     $(this).attr('aria-expanded', false);
   });
 }
 */
  
  $(document).on('click', '.footer_menu h2', function() {
    $(this).parents('.footer--link_list').siblings('.footer--link_list').find('h2 a').removeClass('active').closest('h2').siblings('.toggle_content').slideUp(400);
  });
  
  limitSaleQty();
  
  var lastFocus;
  $(document).on('click', 'a.quick_shop', function() {
    lastFocus = $(this).attr('data-id');    
    var currentProductID = parseInt($('.pdp-cart-items').attr('data-product-id'));
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      success: function (cart) {
        var proceed = true;
        var count = 0;  
        for(var i = 0; i<= cart.items.length-1; i++){
          var cartItem = cart.items[i];
          var carItemProductID = cart.items[i].product_id;
          for(var j = 0; j<= offerProductArray.length-1; j++){            
            if(offerProductArray[j] == carItemProductID){
              if(cartItem.quantity >1){
                count = 2;
              }
              else{
                count = count + 1;
              }
            }
          }  
        }        
        if(count >= 2){
          proceed = false;
          for(var i = 0; i<= cart.items.length-1; i++){
            var cartItem = cart.items[i];
            var carItemProductID = cart.items[i].product_id;
            for(var j = 0; j<= offerProductArray.length-1; j++){
              if(offerProductArray[j] == carItemProductID){
                if(currentProductID == offerProductArray[j]){
                  $('.cart_item[data-id="'+offerProductArray[j]+'"').find('.product-plus').addClass('remove-click').css('pointer-events','none');
                }
              }
            }  
          }                             
          $('.quick-shop .add_to_cart').hide();
          $('.offer-message').show();
          for(var j = 0; j<= offerProductArray.length-1; j++){
              $('.cart_item[data-id="'+offerProductArray[j]+'"]').find('.product-plus').addClass('remove-click').css('pointer-events','none');
          }
        }
        else if(count > 0 && count < 2){
          $('.add_to_cart').show();
          $('.product-plus[data-currentproductexist="true"]').css('pointer-events','none');
          $('.offer-message').hide();
          $('.limit-qty').on('keyup', function(){
            if($(this).val() > 1){
            	$('.limit-qty').val(1);
            }
          })
        }
        else{
          $('.add_to_cart[data-id="'+currentProductID+'"]').show();
          $('.offer-message').hide();
        }  
      }
    });
  });
  
  
  //disable initial offer product inc and dec button from mini cart
  for(var j = 0; j<= offerProductArray.length-1; j++){
    $('.cart_item[data-id="'+offerProductArray[j]+'"]').find('.product-plus').addClass('remove-click').css('pointer-events','none');
  }
  
  if($('body').hasClass('collection')) {
    document.addEventListener('keyup', function(e) {
      if (e.keyCode == 27) {
        if($('.js-quick-shop:visible').length > 0) {
          $('.fancybox-close-small').click();
        }
      }
    });
  }
  
  function setCookie(cname,cvalue,exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  if($('body').hasClass('customers-login')) {
    var cookieVal = getCookie('passwordReminder');
    if(cookieVal != 1) {
      //$('.passwordReminderPopup').fadeIn(300);
    }
  }
  $(document).on('click', '.pr-popupClose', function() {
    $(this).closest('.passwordReminderPopup').fadeOut(300);
    setCookie('passwordReminder',1,30);
  });
    
    
    
    
    
    
      function countDown() {
    // Set the date we're counting down to
    var dateVal = document.getElementsByClassName('countDown')[0].getAttribute('data-date');
    var countDownDate = new Date(dateVal).getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {

      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Output the result in an element with id="demo"
      document.getElementsByClassName("cd-days")[0].innerHTML = days;
      document.getElementsByClassName("cd-hours")[0].innerHTML = hours;
      document.getElementsByClassName("cd-minutes")[0].innerHTML = minutes;
      document.getElementsByClassName("cd-seconds")[0].innerHTML = seconds;

      // If the count down is over, write some text 
      if (distance < 0) {
        clearInterval(x);
        document.getElementsByClassName("cd-days")[0].innerHTML = '-';
        document.getElementsByClassName("cd-hours")[0].innerHTML = '-';
        document.getElementsByClassName("cd-minutes")[0].innerHTML = '-';
        document.getElementsByClassName("cd-seconds")[0].innerHTML = '-';
      }
    }, 1000);
  }
  
  if($('body').find('div').hasClass('countDown')) {
    countDown();
  }
    
    if($( "#date_of_purchase" ).length > 0){
    $( "#date_of_purchase" ).datepicker({
    	dateFormat: "yy-mm-dd"
    });
  }
  
  /*====================================================Gift Form====================================================*/
  $(document).on('click','.tellMore a', function(e) {
    e.preventDefault();
    $('.giftFormWrap').fadeIn(300);
  });
  $(document).on('click','.gf-close', function(e) {
    e.preventDefault();
    $('.giftFormWrap').fadeOut(300);
  });
  
      
      
  $(document).on('click', '.product-plus[data-currentproductexist="true"]',function(){
    if($(this).attr('data-cart') == 'true'){
      alert('Only 1 sale item remaining to be added. You can not add more than 2 sale items.')
      $('[name="quantity"]').val(1);
    }
    else{
      if($('[name="quantity"]').val() > 2){
        alert('We’re sorry, you’ve exceeded your limit for number of sale items in your order.')
        $('[name="quantity"]').val(2);
      }
    }
  })
    var offerCount = 0;  
    var $form = $('#cart_form');
    $form.find('.cartRow').each(function(){
      var offerId = parseInt($(this).attr('data-id'))
      console.log('offerId:'+offerId)
      for(var j = 0; j<= offerProductArray.length-1; j++){              
      if(offerProductArray[j] == offerId)
      	offerCount++;
      	console.log("offerCount:-"+offerCount)   
        if(offerCount == 1){
          var vals= $('[data-id='+offerProductArray[j]+']').find('.quantity').val();
          console.log('val'+vals)
          if(vals >= 2){
              $("[data-id="+offerProductArray[j]+"]").find('.product-plus').css('pointer-events','none');
          }
          else{
          	$("[data-id="+offerProductArray[j]+"]").find('.product-plus').css('pointer-events','');
          }
        }
        else{
          $("[data-id="+offerProductArray[j]+"]").find('.product-plus').css('pointer-events','none');
        }
      }  
    })
    
    $(document).on('click', '.cart .product-plus',function(){
      var $form = $(this).parents('#cart_form');
      $form.find('.js-change-quantity').css('pointer-events','none');
    })

    // Collection Filter dropdown toggle
    $(document).on('click','#custom-filter-toggle', function(){
      var _this = $(this);
      var _filterContainer = $('body.collection div.sidebar');
      var _ariaStatus = _this.attr('aria-expanded') == 'true' ? 'false' : 'true';
      _this.attr('aria-expanded', _ariaStatus);
      _filterContainer.slideToggle();
    });
});

/*#################### Custom code ##############*/

function getCartInfo(currentProductID, cart){  
  var proceed = true;
  var count = 0;  
  for(var i = 0; i<= cart.items.length-1; i++){
    var cartItem = cart.items[i];
    var carItemProductID = cart.items[i].product_id;
    for(var j = 0; j<= offerProductArray.length-1; j++){
      if(offerProductArray[j] == carItemProductID){
        if(cartItem.quantity >1){
          count = 2;
        }
        else{
          count = count + 1;
        }
      }
    }  
  }

  if(count >= 2){
    console.log('count:-'+count)
    proceed = false;
    for(var i = 0; i<= cart.items.length-1; i++){
      var cartItem = cart.items[i];
      var carItemProductID = cart.items[i].product_id;
      for(var j = 0; j<= offerProductArray.length-1; j++){
        if(offerProductArray[j] == carItemProductID){
          if(currentProductID == offerProductArray[j]){
            $('.add_to_cart[data-id="'+currentProductID+'"]').hide();
            $('.offer-message').show();
            $('.cart_item[data-id="'+offerProductArray[j]+'"').find('.product-plus').addClass('remove-click').css('pointer-events','none');
          }
        }
      }  
    } 
    for(var j = 0; j<= offerProductArray.length-1; j++){
      if(currentProductID == offerProductArray[j]){
        $('.cart_item[data-id="'+offerProductArray[j]+'"]').find('.product-plus').addClass('remove-click').css('pointer-events','none');
      }
    }
  }
  else if(count > 0 && count < 2){
    $('.limit-qty').attr('data-cart','true');
    proceed = true;
    for(var j = 0; j<= offerProductArray.length-1; j++){
      if(currentProductID == offerProductArray[j]){
        $('.add_to_cart[data-id="'+offerProductArray[j]+'"]').show();
        $('.product-plus[data-currentproductexist="true"]').css('pointer-events','none');
        $('.offer-message').hide();        
      }
    }
  }
  else{
    console.log('count:-'+count)
    $('.limit-qty').removeAttr('data-cart','true');
    proceed = true;
    $('.add_to_cart[data-id="'+currentProductID+'"]').show();
    $('.offer-message').hide();
  } 
  
}
           
function limitSaleQty(){
  $('.limit-qty').on('keyup', function(){
    if($(this).attr('data-cart') == 'true'){
      if($(this).val() > 1){
        $('.limit-qty').val(1);
      }
    }
    else if($(this).val() > 2){
      $('.limit-qty').val(2);
    }
  })
} 

function checkCartItems(){    
 var currentProductID = parseInt($('.pdp-cart-items').attr('data-product-id'));
  $.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      success: function (cart) {
        var checkForError = getCartInfo(currentProductID, cart);
      }
    });
}

/* =====================================Script for ADA Fixtures=================================*/

/*===========================================Placeholder Label===========================================*/

  $(document).keyup(function(e) { 
    if(e.keyCode === 13) {
      if(!$('.fancybox-container.fancybox-is-open').hasClass('product-section__lightbox')) {
        $(document.activeElement).click();
      }
    }
  });


  $('.newletterInputWrap input').keyup(function() {
    var inputVal = $(this).val();
    if(inputVal != '') {
      $(this).closest('.newletterInputWrap').addClass('focus withVal');
    }
    else {
      $(this).closest('.newletterInputWrap').removeClass('focus withVal');
    }

  });

  $(document).on('click', '.ca_flap.ca_tab', function() {
    $('.close.ca_tab').attr('role','button');
    $('.close.ca_tab').attr('tabindex','0');
    $('.close.ca_tab').removeAttr('title');
    $('.close.ca_tab').attr('aria-label','Close');
//     $(this).attr('aria-controls','sa_ca_content');
    setTimeout(function() {
      $('.sa_ca_content').attr('id','sa_ca_content');
      $('.sa_ca_content .sa_ca_item').each(function(i) {
        var altText = $('.sa_ca_content').find('.sa_ca_item').eq(i).find('.sa_ca_summary .sa_ca_ptitle').text();
        $('.sa_ca_content').find('.sa_ca_item').eq(i).find('.sa_ca_pimg img').attr('alt',altText);
        $('.sa_ca_content').find('.sa_ca_item').eq(i).find('.sa_ca_idelete').attr('aria-label','Remove');
        $('.sa_ca_content').find('.sa_ca_item').eq(i).find('.sa_ca_idelete').attr('role','button');
        $('.sa_ca_content').find('.sa_ca_item').eq(i).find('.sa_ca_idelete').attr('tabindex','0');
        $('.sa_ca_content').find('.sa_ca_item').eq(0).find('.sa_ca_idelete').focus();
      });     
    },500);
    if($(this).attr('aria-expanded') == "false" || !$(this).attr('aria-expanded')) {
      $(this).attr('aria-expanded',true);
    }
    else {
      $(this).attr('aria-expanded',false);
    }
  });

  /* Retain focus inside modal window on pressing Shift+Tab */
  $('body').on('keydown blur', ".sa_ca_container", function(e) {
   e.preventDefault();
   if (e.shiftKey && e.keyCode === 9) {
     $('.footer-bottom-links li:last-child a').focus()
   }else if (e.keyCode === 9) {
     if ($('body').hasClass('customer-logged-in')) {
       const wishListItems = $('#swym-anchor .swym-anchor-badge').data('count');
       if (+wishListItems && $('.swym-heart:visible').length !== 0 ) {
         $('#swym-anchor #notepad-anchor-title').focus()
       } else {
         $('.js-main-header .logo a').focus();
       }
     } else {
       $('.js-main-header .logo a').focus();
     }
   }
  });

  $('body').on('keydown blur', ".footer-bottom-links li:last-child a", function(e) {
  if (e.keyCode === 9) {
    e.preventDefault();
    if ($('body').hasClass('customer-logged-in')) {
      if ($('.ca_flap.ca_tab').length) {
        $('.ca_flap.ca_tab').attr('tabindex','-1').focus()
      } else if($('#swym-anchor:visible')) {
        $('#notepad-anchor-title').focus()
      } else {
        $('.js-main-header .logo a').focus();
      }
    }
  }
});

  $('body').on('keydown blur', "#swym-anchor #notepad-anchor-title", function(e) {
    e.preventDefault();
   if (e.shiftKey && e.keyCode === 9) {
     $('#sa_ca_wrapper .sa_ca_container .ca_flap').focus();
   } else if (e.keyCode === 9) {
     $('.js-main-header .logo a').focus();
   }
  });
  
  $(document).on('click','.close.ca_tab', function() {
    $('.ca_flap.ca_tab').attr('aria-expanded',false);
  });
  
  $(document).on('keydown','.close.ca_tab', function(e) {
    if(e.keyCode == 9){
      setTimeout(function() {
        var altText2 = $('.sa_ca_content').find('.sa_ca_item').eq(0).find('.sa_ca_summary .sa_ca_ptitle').text();
        console.log(altText2);
      	$('.sa_ca_content').find('.sa_ca_item').eq(0).find('.sa_ca_idelete').focus();
      },500);
    }
  });
  /*===========================================Placeholder Label End===========================================*/

/*=================================Compare button=================================*/

  var btnRole = setInterval(function() {
    if($('.ca_flap.ca_tab').length > 0) {
      $('.ca_flap.ca_tab').attr('role','button');
      $('.ca_flap.ca_tab').attr('tabindex','0');
    }
  },500);
  setTimeout(function() {
    clearInterval(btnRole);
  },10000);
  /*==================================Compare Button End=================================*/

$(window).on('load', function(){

/* =====================================Be In The Know Modal=================================*/
  
  function beInKnowFun() {    

    $($('.popup-dialog img[data-popup-image-type="upload"]'),".popup-dialog").bind("keydown", function(e){
      if ( e.keyCode === 9 )
      {
        var ele;
        if($('.popup-dialog a[href]').length  > 0) {
          ele = $('.popup-dialog a[href]')
        }
        else {
          ele = $('.popup-dialog input')
        }
        var firstElem = $(ele,".popup-dialog");
        firstElem.focus();
        return false;
      }
    });
        
    /* Retain focus inside modal window on pressing Shift+Tab */
    $(".popup-dialog").on('keydown blur', function(e) {
      if (e.shiftKey && e.keyCode === 9) {
          return false;
      }
    });
  }
  
  var a = 0;
  var beInKnow = setInterval(function() {    
    if($('.popup-dialog').length > 0) {
      $('.popup-dialog').attr("role","dialog");
      $('.popup-dialog').attr("aria-modal","true");
      $('.popup-dialog').attr("aria-label","sign up");
      $('.popup-dialog a[submit-button-disabled=1]').attr("tabindex","-1");
      $('.popup-dialog a[submit-button-disabled=1]').attr("aria-disabled","true");
      $('.popup-dialog .popup-content > div >div >div:first a').attr({'role' : 'button', 'aria-label' : 'Sign Up'});

      $('.popup-dialog img[data-popup-image-type="upload"]').attr('aria-label','Close');
      $('.popup-dialog img[data-popup-image-type="upload"]').attr('role','button');
      $('.popup-dialog img[data-popup-image-type="upload"]').attr('tabindex','0');
      $('.popup-dialog img[data-popup-image-type="upload"]').focus();      
      $('.popup-dialog .popup-content >div >div').find('h2').remove();
      var classname = $('.popup-dialog .popup-content > div > div').attr('id');
      if(classname.includes('popup-confirmation')){
          $('.popup-dialog .popup-content >div >div').prepend('<h1 class="screen-reader-only">Thank You</h1>');
        var popupText = $('.popup-dialog .popup-content >div >div >div:nth-of-type(2) img').attr('id');
        var popupClose = $('.popup-dialog .popup-content >div >div >div:nth-of-type(4) img').attr('id');
        if(popupText.includes('popup-confirmation-texts-logo')){
        	$('.popup-dialog .popup-content >div >div >div:nth-of-type(2) img').attr('alt', 'Thank You');
        }
        if(popupClose.includes('popup-confirmation-texts-logo')){
          $('.popup-dialog .popup-content >div >div >div:nth-of-type(4) img').attr({'aria-label' : 'Close', 'role' : 'button', 'tabindex' : '0'});
        }
      } else{
      	$('.popup-dialog .popup-content >div >div').prepend('<h1 class="screen-reader-only">Be In The Know</h1>');
      }
      var a = document.getElementsByClassName('popup-dialog')[0];
      a.getElementsByTagName('img')[0].setAttribute('alt','Be In The Know');
      $('.popup-dialog input:visible').keyup(function() {
        if($('.popup-dialog a[submit-button-disabled=1]').length > 0) {
          $('.popup-dialog a[submit-button-disabled=1]').attr("tabindex","-1");
          $('.popup-dialog a[submit-button-disabled=1]').attr("aria-disabled","true");
          $('.popup-dialog a[submit-button-disabled=1]').removeAttr("href");

        }
        else {
          $('.popup-dialog .popup-content > div >div >div:first a').attr("tabindex","0");       
          $('.popup-dialog .popup-content > div >div >div:first a').attr("href","javascript:void(0)");
          $('.popup-dialog .popup-content > div >div >div:first a').removeAttr("aria-disabled");
        }

      });
      beInKnowFun();
    }
    else {
    }
  },500);    
  
  setTimeout(function() {
    clearInterval(beInKnow);
  },60000);
  
  /* =========================================Be In The Know Modal End =================================*/

  if($('body').hasClass('customer-logged-in')) {
    setTimeout(function() {
      if($('.swym-heart').length > 0) {
        $('.swym-heart .swym-icon').attr('aria-hidden',true);
      }
    },1000);  
  }
  $(document).find('.slider-gallery.products-slider').attr({'role' : 'region', 'aria-label' : 'Product Slider'});
  var headingOuterHTML = $('.sku_collectionWrapper').siblings('.product_name').eq(0).clone();
  $('.sku_collectionWrapper').siblings('.product_name').attr('aria-hidden', 'true');
  $('#main-content').prepend(headingOuterHTML);
  $('.product_name').first().addClass('screen-reader-only');
  
  /* ==================================CSV Script==================================*/
  function insert(str, index, value) {
    return str.substr(0, index) + value + str.substr(index);
  }
  
  function onlyUnique(value, index, self) { 
    return self.indexOf(value) === index;
  }
  function csvJSON(csv){

      var lines=csv.split("\n");
      var result = [];

      var headers=lines[0].split(",");    

      for(var i=1;i<lines.length;i++){

        var obj = {};
        var currentline=lines[i].split(",");
        for(var j=0;j<headers.length;j++){  
          obj[headers[j]] = currentline[j];
        }
        result.push(obj);

      }
      return result; //JSON.stringify JSON
    }
  if($('div.storeListingWrap').length > 0) {
    var csvFile = '//costco.briggs-riley.com/cdn/shop/t/29/assets/Store_Listings_0429.csv?v=180959251804753395791774556464';
    
    $.ajax({
      url: csvFile,
      method: "GET", 
      crossDomain: true,
      //         dataType: "json",
      success: function(response) {

        var storeArray = csvJSON(response);
        
        console.log(storeArray);

        var sortObj = [];
        let field='Region';
        //var sortedObject = storeArray.sort(function(a, b) { return (a[field] || "").toString().localeCompare((b[field] || "").toString())}); // For Region sorting
        var sortedObject = storeArray;
        var item = '';
        var objLen = sortedObject.length;
        var itemTest = '';
        
        for(var i=0; i<objLen; i++) {
          if((sortedObject[i]).Region != undefined && (sortedObject[i]).Region != '' && (sortedObject[i]).Region != null) {

            var Region = sortedObject[i];
            var curRegion = (sortedObject[i]).Region;
            if(curRegion == undefined || curRegion == null) {
              curRegion = '';
            }
            
            if(i > 0) {
              var prevRegion = (sortedObject[i-1]).Region;
            } else {
              var prevRegion = '';
            }

            if(prevRegion == undefined || prevRegion == null) {
              var prevRegion = '';
            }

            //console.log('curRegion: ',curRegion,' prevRegion: ',prevRegion,' curRegion.trim() ',curRegion.trim() != prevRegion.trim());
            if(curRegion.trim() != prevRegion.trim()) {
              var item = '';
              //  console.log('ddddddd: ',i);
              var itemH ='<h2 id="'+curRegion+'">'+curRegion+'</h2>';
              item += '<div class="eachStore">';
              item += itemH;

              
              var stateH = [];
              var eachState = [], eachStore = [];

              for(var j=0; j<objLen; j++) {
                if(sortedObject[j].Region != undefined && sortedObject[j].Region != null) { 
                  var sortedRegion = sortedObject[j].Region;
                } else {
                  var sortedRegion = '';
                }
                
                if(sortedRegion.trim() == curRegion.trim()) {
                  if(curRegion == 'Canada') {
                    stateH.push(sortedObject[j].State.charAt(0));
                  } else {
                    stateH.push(sortedObject[j].State.charAt(0));
                  }

                  eachStore.push(sortedObject[j]);
                }
              }

              if(curRegion == 'Canada') {
                var value = 'State';
              } else {
                var value = 'State';
              }

              item += '<p class="stateHeading">'+value+'</p>';
              var uniqueState = stateH.filter( onlyUnique );
              var sortedState = uniqueState.sort();

              var sortedStore = eachStore.sort(function(a, b) { return (a[value] || "").toString().localeCompare((b[value] || "").toString())});

              for(var k=0; k<sortedState.length;k++) {
                item += '<a href="#'+sortedState[k]+'_" class="backToSection">'+sortedState[k]+'</a>';
              }
              item += '</div>';

              var sortedStoreLen = sortedStore.length;
              item += '<div class="eachStoreTable">';
              var arrayTest = [];
              var itemInner = '', itemInnerTest = '';
              for(var l=0; l<sortedStoreLen; l++) {
                if(l == 0) {
//                  item += '<p class="charHeader">'+sortedStore[l].State.charAt(0)+'</p>';
                  var prevChar = '';
                }
                else {
                  if(curRegion == 'Canada') {
                    var prevChar = sortedStore[l-1].State.charAt(0);
                  }
                  else {
                    var prevChar = sortedStore[l-1].State.charAt(0);
                  }
                }
                if(curRegion == 'Canada') {
                  var currentChar = sortedStore[l].State.charAt(0);
                }
                else {
                  console.log(sortedStore[l], sortedStore[l].State);
                  var currentChar = sortedStore[l].State.charAt(0);
                }
                var Retailer = sortedStore[l].Retailer ? '<strong>'+sortedStore[l].Retailer+'</strong>' : '-';
                var Addr1 = sortedStore[l]["Address 1"] ? '<br>'+sortedStore[l]["Address 1"] : '';
                var Addr2 = sortedStore[l]["Address 2"] ? '<br>'+sortedStore[l]["Address 2"] : '';
				        var City = sortedStore[l].City ? sortedStore[l].City : '-';
                var State = sortedStore[l].State ? sortedStore[l].State : '-';
                var Zip = sortedStore[l].Zip ? sortedStore[l].Zip : '-';
                var Phone = sortedStore[l].Phone ? sortedStore[l].Phone : '-';
                
                if(currentChar != prevChar) {
                  //item += '<div id="'+sortedStore[l].State.charAt(0)+'">'+sortedStore[l].State.charAt(0)+'</div>';
                  if(l > 0) {
                    //item += '</table>';   //'<p '+l+' class="charHeader">'+sortedStore[l].State.charAt(0)+'</p>';
                    //itemInner += '</table>';
                    itemInnerTest += '</table>';
                    var itemEnd = '</table>';
                    //console.log('itemInnerTest: ',itemInnerTest);
                    var itemInnerTestFinal = itemInnerTest.replace('<table class="storeTable">','');
                    itemInnerTestFinal = itemInnerTestFinal.replace('</table>','');
                    arrayTest = itemInnerTestFinal.split('<tr class="blank"></tr>');                    

                    // arrayTest.push(itemInnerTest);

                    var sortedArrayTest = arrayTest;
                    
                    var sortedArrayToStr = sortedArrayTest.toString();
                    // console.log('arrayTest: ',sortedArrayToStr);
                    var arrayTestInd = sortedArrayToStr.indexOf('<tr>');
                   	sortedArrayToStr = insert(sortedArrayToStr,arrayTestInd,'<table class="storeTable">');
                    var lastarrayTestInd = sortedArrayToStr.lastIndexOf('</tr>');
                    sortedArrayToStr = insert(sortedArrayToStr,lastarrayTestInd+5,'</table>');
                    itemInner += sortedArrayToStr.replace(/,/g,'');
                    arrayTest = [], itemInnerTest = '';
                    //arrayTest.push(itemInner);
                  }                  
                  var itemHeader = '<div id="'+currentChar+'_'+l+'" class="charHeader">'+currentChar+'<a href="javascript:void(0)" class="backToTop ">Top</a></div><table class="storeTable">'+
                    '<tr>'+
                    '<th>name and address</th>'+
					'<th>city</th>'+
                    '<th>state</th>'+
                    '<th>zip</th>'+
                    '<th>phone</th>'+
                    '</tr>';
                  //arrayTest.push(itemHeader)
                  //var staData = {'addr':'','state':'','zip':'','phone':''};
                  var itemTestHeader = 'Head';
                }
                else {
                  itemHeader = '';
                  var staAddr = Retailer+' '+Addr1+' '+Addr2
                  var staData = {'addr':staAddr,'state':State,'zip':Zip,'phone':Phone};
                  itemTestHeader = '';                                    
                }
                
                //itemTest +=
                //arrayTest.push()
                //console.log('StoreArray: ');
                //item += itemHeader+'<tr>'+
                 // '<td data-header="name and address"><p>'+Retailer+' '+Addr1+' '+Addr2+'</p></td>'+
               // '<td data-header="state">'+State+'</td><td data-header="zip">'+Zip+'</td><td data-header="phone">'+Phone+'</td></tr>';
                //console.log('Last ele: ',l,l == sortedStoreLen-1);                
              
                //itemInner += itemHeader+'<tr class="blank"></tr><tr>'+
                  //'<td data-header="name and address"><p>'+Retailer+' '+Addr1+' '+Addr2+'</p></td>'+
                //'<td data-header="state">'+State+'</td><td data-header="zip">'+Zip+'</td><td data-header="phone">'+Phone+'</td></tr>';
                
                itemInnerTest += itemHeader+'<tr class="blank"></tr><tr>'+
                  '<td data-header="name and address"><p>'+Retailer+' '+Addr1+' '+Addr2+'</p></td>'+
                '<td data-header="city">'+City+'</td><td data-header="state">'+State+'</td><td data-header="zip">'+Zip+'</td><td data-header="phone">'+Phone+'</td></tr>';
                
                if(l == sortedStoreLen-1) {}
              }

              item += itemInner+itemInnerTest+'</div>';
              
              $('#storeListingWrap').append(item);    
            }
          }
        }
      },
      error: function(error) {
        console.log('Error:', error);
      }
    });
    
    $(document).on('click', '.backToTop', function() {
      $('html,body').animate({'scrollTop': 0},300);
    });
    
    $(document).on('click', '.backToSection', function() {
      var sectionId = $(this).attr('href');
      var noHash = sectionId.split('#')[1];
      console.log('noHash: ',noHash);
      var sectionToGo = $(this).closest('.eachStore').next().find('div[id*='+noHash+']');
      console.log('sectionToGo: ',sectionToGo);
      if(sectionToGo.length > 0) {
        var sectionScroll = sectionToGo.offset().top; //[name*='man']
        console.log('sectionScroll: ',sectionScroll);
        $('html,body').animate({'scrollTop':sectionScroll - 100},300);
      }
    });

  }
  /* ==================================CSV Script End==================================*/
  
});

$('[data-fancybox="size_chart"]').on('click', function(){
  setTimeout(function(){
    $(document).find('.fancybox-container .fancybox-content').attr({'role' : 'dialog', 'aria-modal' : 'true', 'aria-label' : 'Size Guide'});
    $(document).find('.fancybox-container .fancybox-content').prepend('<h1 class="screen-reader-only">Size Gide</h1>');
    $(document).find('.fancybox-container .fancybox-image-wrap img').attr('alt', $('[data-fancybox="size_chart"]').data('alt'));
  },1000);
});

$('button[data-fancybox-close]').on('click', function(){
  console.log('Here');
  $(document).find('#fancybox-container-1 .fancybox-content').find('h1.screen-reader-only').html(' ');
  setTimeout(function(){
    console.log($(document).find('.gallery-cell').hasClass('is-selected'));
    if($(document).find('.gallery-cell').hasClass('is-selected')){
      $(document).find('.gallery-cell.is-selected').find('a.lightbox').focus();
    }
    $(document).find('a.quick_shop [data-id =' + lastFocus).focus();
  },100);
});

$('.relative.product_image a').attr('tabindex', '0');

$('.custom-monogram-popup-close').on('click', function(){
	$(document).find('.custom-monogram-link').focus();
});	

$(window).on('load', function(){
  $('#cart_form .subtotal').css({'pointer-events': 'all', 'opacity': 1})
});

const $subscribeForms = document.querySelectorAll('.js-subscribe-form');
if ($subscribeForms.length) {
  $subscribeForms.forEach(function (form) {
    const $inputWrappers = form.querySelectorAll('.js-floating-wrapper');
    if ($inputWrappers.length) {
      floatingFormLabel($inputWrappers);
      form.addEventListener('change', function() {
        floatingFormLabel($inputWrappers);
      });
    }
  });
}

function floatingFormLabel(inputWrappers) {
  inputWrappers.forEach(function (wrapper) {
    const $input = wrapper.querySelector('input.floating-label__input');
    if ($input) {
      $input.addEventListener('focus', function() {
        wrapper.classList.add('has-focus');
        wrapper.classList.add('is-floating');
      });
      
      $input.addEventListener('blur', function(event) {
        wrapper.classList.remove('has-focus');

        if(event.target.value === '') {
          wrapper.classList.remove('is-floating');
        }
      });
    }
  })
}

window.addEventListener('load', function () {
  if ( document.querySelector('body').classList.contains('search') ) {
    const $productSearchListWrapper = document.querySelector('.js-search-product-list');
    const $productSearchList = $productSearchListWrapper.querySelectorAll('.product-wrap');

    if ($productSearchList.length) {
      $productSearchList.forEach(function (product) {
        const $swatch = product.querySelectorAll('.swatch a');
        if ($swatch.length > 1) {
          $swatch[0].click();
        }
      })
    }
  }
});


